
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import HeaderTitle from './HeaderTitle.vue';
import ActionButton from './ActionButton.vue';
import { StoreModel } from '@/models/store';
import { EventBus } from '@/main';
import { avatarColor } from '@/services/configs';
import { Title } from 'chart.js';

@Component({
  components: {
    HeaderTitle,
    ActionButton,
  },
})
export default class VerticalMenuBar extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: false })
  public isEmbeddedMode!: boolean;
  public mini: boolean = true;
  public search: string = '';
  public menuPurpose: string = '';
  public canExpandOnHover: boolean = true;

  public get getMenuItems() {
    //check if the store is free package
    // if (this.store.currentPackage && this.store.currentPackage.name === 'Free') {
    //   return this.freeMenu;
    // }
    const storeId: number = this.store.id;
    if (this.store.shopName === 'assisty-demo.myshopify.com') {
      return this.replenishmentMenu;
    }
    if (storeId > 9683) {
      return this.replenishmentMenu;
    }
    if (this.store.shopName === 'assisty-demo.myshopify.com') {
      this.menuPurpose = 'replenishment';
    }
    if (this.menuPurpose === 'replenishment') {
      return this.replenishmentMenu;
    }
    return this.FullMenu;
  }
  public pinMenu() {
    EventBus.$emit('pin-menu', this.canExpandOnHover);
    this.canExpandOnHover = !this.canExpandOnHover;
  }
  public replenishmentMenu: any[] = [
    {
      section: 'replenishment',
      title: 'Replenishment',
      items: [
        {
          title: 'Demand forecasting',
          icon: 'mdi-chart-timeline-variant-shimmer',
          type: 'group',
          items: [
            {
              title: 'Historical sales-based',
              link: '/reports/38/demand-forecasting/609?report_query=eJzNWMFu4zYQ%2FRWBQIEWtbaSbMVJbtkUBYJ2u2ntBCiCQGAkxmGXElWScmsE%2BfcOJVkc0U5ioz1sDgE0fJwZziOHj34mhhvByDm5qtasMlJtgp%2BkYjnVhler4GET3FLFaWXIhORPVJnlprbwxc2nTxe%2F%2FwHWJ6ov7QA5N6phE6Kf5N%2B94ZEKbS1MsNyw4pKq4lKKpqw0Ob97JhUtrSsUQBbWsB4MBTW0D2jYP9YiGq4%2F0bqG5Mh51QjxMhkcbRMPFlQwHfzWgBNuNs7x3WOPyLRFZH%2F1iPtxqILlvKTCj0ZemU1QCktpqAhuKm50sJCiQLEba8w0GDO%2BrXVWC1pV4P3ADN70QV7uJ6RkVDfK%2BnCAR0eoDcNLVmkuK8A8bDJXbG2AtMzwdiFJlMzCaB7GpzDCqmJkj6MwnltX7JE2wmSKVis7OC3B%2BMiFYQoIhmxqvpYmk7XpwsFoTRUtR%2FQPrC0hQvBtQTf6O1e2oeZt%2FAnsDdGA%2FY5MI3Lff%2FZF07A%2BwcaFrJryAZKBxUllPqvCJkbiKLKVlbRoq9ruUsThRfFno2G7BksFC3epdKyb3jgkEvt5CK7NK1nYoVsL7SrAC3J%2BOiG%2F0AcmAPY9JPYNoG471yT5ELV7y8LOEOxshIo%2FnA2oOEKwUw926mAxgs092NzBEgQ78WAnDjZFsNSDpQ42Q7CZB5s5WIpgUw82dbATBEs8WOJg81F5x7DYwTALY5TDIArCsasIUZAgCsLEgzkKEkRBOPVgjoIEURDOPJijIEEUhKkHcxQkiILwxIM5ChJEQTj3YI6CBFEQnnowR0GCKAjPPFjcNi18OGdvns0FXC7BUtbuVBpZV%2Fg4XghxSGPYXie7BzJFy0pRsq6MKVpRHOHN4s5rinZUgjEJwqAdlWJM6jAnaDvZpTmQ%2FfKLd2b%2Fdut37%2B7gTLEaJmT57j18rWTR5Ca4KumKuQLz9hNx0OMc4sqw8s7%2BC35kOle8bff3%2B%2Bs9us7g%2Bql7Z8j%2F%2F6YHFj%2FfOCd9oEx%2FaY7KrJ3wdYkML4WLUja4XH4CtB33wueNgoss37wXv5u8N7pTjNsiBL8yhiXPXglyYB32y5d9eXxeM6WNzL%2Bw4geQXsXw9SY5EmZljUVnLfxYevz5X48KREpmvUJZBDVTAcgrlA1drzLr7T8m9J6bUU5bdfVOYkxB28kKysUmQwtGIuzg5N53hRMcNrOsgieKBeDdRW4aIHZ34x%2BYyqvzcfyrKpelfXsNsNGJ6gaP7So78%2FaepGWnsXfOitXeXiAnafcfj1auv9012ovMbxmDA7eL2qv86Pblzce52J0XXEptvHMJl6I%2BuE8OE7DnBRPCUneteI4rObIfGMG7zNBxgUf5opU0en9j6fTO8c2k10mvBv0I7e7VoA%2Ft4PFBu3mtkqntMe0eiyBMnttv0N0TwkFb6GumrltDGnWi5%2BPG6r33OmqvkKwyAbj9iQIsKyWbup2%2F%2FejH7Qsa2tNCop8vSnjicmR5mTgxwVbwmIbNBkoNssqpyBtBrcwqmQGudecSzh68e7mWFXQhA0t4fnn5F%2Ba4x3w%3D',
            },
            {
              title: 'Top overstocked products',
              link: '/reports/30/demand-forecasting/609?report_query=eJzNmG1vo0YQgP8KQqp0VcwV8Gv8zZeqUtSml56dSJUVoTVsnO0tLGUXt1bk%2F95ZIOywIY6t3of7EoXl2ZnZedvBz65iilN37q5E7ogdLaQS8VeaOHkhkjJW0h248RMp1Gqfa2x5d3Oz%2BPInrD4ReaVfuHNVlHTgyifxT7PwSLjUK5TTWNHkihTJleBlmkl3vn52M5JqUfekYCRTWoFI9MKuXUiIIo1CRf%2FVK7xk8obkOcu27jwrOT8MWkG%2FiILGRCpnSTiVzh8lCGFqbwSvHxsikpqI%2Fm6Ih66qhMYsJdzW5r6x20UmrIQi3LnLmJLOUvAE6S71YiRhMWLZjmZKFPso5yTLQPqJFhyV4R4eBm5KiSwLLcMAL3ZrBtSwlGaSiQyYzT4yzpYKghYpVh0k9MOR50%2B9YAZvaJZ01gPfC6ZaFH0kJVdRQbKtfjlMYfGRcUULHOA2Lp9NXv0ETkpMlh2Llc7GqNR0VOHaVzvCS6DWru%2FCoUVOCwJHhW1b1e9J7Zuc7QSIy1V9eABzUpC0k4xLyF4HasAYokSeYY0LzrXO6rlRIsGzUDy9%2BcqkutdorYUl7nw8Gbi%2FkQ3lQI0Bua8lw%2F86kSpiaojARwg8tMzMMCFmQsRcIk2YGRtm4htGH81A%2Bkm7jQuSVOlXlTNK9kXyVymhrp1VARliPFaXh2oWW8cFttu0b7pOy8p0A7nT6zZ03ovA93%2FAR%2F5ozoOOfHHZoYKPly0VoFNfzCxsZrAAYVMLmxosRNjEwiYGGyJsbGEm%2BsEIYSMLGxlsjLChhQ0NhrLtIrSw0GDTjnu7WGAwHIUuZRgUAq8rykchCFEIvNDCTAhCFAJvaGEmBCEKgTeyMBOCEIXAG1uYCUGIQuBNLMyEIEQh8KYWZkIQohB4MwszIQhRCLxLCwuOl2LbYlfQpp0PCdnLH01Btq20auKoJIf%2BKa3MVGVX%2FYO52qOC5gJuj%2Fj19X5bDxDOdUq21NjEqkd0hIYzxLWi6Vr%2FcX6mMi5Y1beti7JvKtC3WjO1YPnfbMxY%2FnpnhDSKIvm1PMuyasP3NbtYJixSUWJ32QaQ6r2lPi4LaPvx%2Fj399eZe7dcvc0vrBOd3SvEk1TvZnOiH%2Fqmoz45vN6ycEx57%2F%2FczXKJ7f7dFVjgwfDnQcJA1ZLeNtLT%2FadB7Yty%2BWeQdw2BQ3NIoIYzvI3RgNLKcbNz7orCBbTKLzHkieFxaL2JVQmBfJ%2F6Jpry5H%2Bu%2FzmKRAm%2BwTkXVL8%2FtKq%2F29VbSqr51XtWKvo0sReaq6S%2BP6gI73jWqO9NuGa0Ak0XVrXd2%2B7L2Y1t05jlXQiqrLuFSlCf3yXYDlryknOvQ3RYsxp7srJ%2BowbrMULls9s6yuv1lf2OpR4Pzm0kzUryp9BO0uzeVbqqX5yut99WffbpM668%2BGEyeq2eYUgcug9lC3tLitloYwzwqYYb5tNeT0bGO%2FlCDeioBVP%2FqASvbQpR5tffloXmvP8qhNS0F%2BkUkha9mhlYOAzNI0C18n0OiwUQIFsWExyUnesRKqYI4y1ok1B18vDIpMuhACsx%2FPhz%2BA4LN5IQ%3D',
            },
            {
              title: 'Top understocked products',
              link: '/reports/36/demand-forecasting/609?report_query=eJzNmF9v2zYQwL%2BKIGBAh1idJMdx4jc3w4Bgy5rVToDBCARGYhyulKiRlDcj8HffUVLEE6M4NtaHvgQR9ePd8f7x5GdfM82pP%2FOXovRui4xKb6FF%2BtW7I5KRQit%2F5KdPROrltjTY4vb6ev7lT1h9IurSvPBnWlZ05Ksn8U%2B78Ei4MiuU01TT7JLI7FLwKi%2BUP1s9%2BwXJjahWg1EgMrOw6RYyokmrUNN%2FzQqvmLomZcmKtT8rKs53o07QL0LSlCjtLQinyvujAiFMb63g1WNLJMoQyd8tcd9XldGU5YS72vw3dvvIhKXQhIP%2FmFbeQvAM6a7MYqJgMWHFhhZayG1SclIUIP1AC%2FbK8Hf3Iz%2BnRFXSyLDAi92GATUsp4ViogDmYZtYZysNQUs0qw8Sh%2FFpEE6D6Bze0CLrrUdhEE2NKPpIKq4TSYq1eTnOYfGRcU0lDnAXl88bKpXJKpr91CRZ%2B7Q3VgJ2JZWhkxo3vtoQXgG18kMfDi1KKgkcFbZxPexJ45uSbQSIK3VzeABLIkneS8YFZK8HNWAN0aIssMY550Zn%2FdwqUeBZKJ7BfGVK3xm00cIyfzY5G%2Fm%2FkQfKgZoActdIhv9NItXE1BJRiBB46Jhzy8SYiRFzgTRhZmKZs9Ay5mgWMk%2FGbVyQrE6%2FupxRss%2BzvyoFde0tJWSI9VhTHrpd7BwXuW4zvuk7rajyB8idQbeh855EYfgDPvJHex505JOLHhV9vOioCJ365NzBzi0WIWzqYFOLxQg7c7Azi40RNnEwG%2F3oFGGnDnZqsQnCxg42thjKtpPYwWKLTXvu7WORxXAU%2BpRlUAiCvqgQhSBGIQhiB7MhiFEIgrGD2RDEKATBqYPZEMQoBMHEwWwIYhSC4MzBbAhiFIJg6mA2BDEKQXDuYDYEMQpBcOFg0f5S7FrsEtq09yEjW%2FWjLciuldZNHJXkODykldmq7Ku%2Ft1d7Imkp4PZIX1%2FvN1JkVaq9q5ysqbWJ1Y%2FoCC1niStN85X54%2F1MVSpZ3bedi3JoKjC3WtkKQ%2FK%2F2Zix%2BPXWCmkVJeprdZRl9Ybva3ZxTJjnosLucg0g9XtHfVpJaPvp9j39zeZB7Vcvc0vnBO93SvEkNTjZHOiH4aloyI5vN6wcEx53%2F%2FczXKJ7f7NGVngwfHnQcJA1ZLNOjLT%2FadB7YvyhWeQdw2BQXNMkI4xvE3RgNLIcbNz7orCBXTKLwnsieFxazVNdQWBfJ%2F6Bpry5H%2Bu%2FKlKRA2%2BxXkU1L4%2FtKq%2F2DVbSsrl1XtWKuY0cRfaqGS6P%2BgLb3zXqO9NtGZ0Am0X1rXd0%2B3L2Y1tM5nmXQmmnLuFSVAf3yW4DlrygnJvQ3UiWYk%2F21g%2FU4FxmqFwett6ivv3VcGNpRoPjm0k7Uryp9BO0uzeVPtQvj1fa7Gs%2B%2B0yZNl99MJg8188wpY58BrOFuqHypl6YwDyqYIb5tDWT0b6Oft%2BAZioBtJ6FYGktRVXWm18eWsB8lUNvWgj0k0gOn80MrexGdpKga%2FhAh0yDkRBMSglPK07MjJVTDYFWjUgoPPh6ZUoU0II02P%2B82%2F0HSJTkIQ%3D%3D',
            },
            {
              title: 'Inventory movement-based',
              link: '/reports/38/demand-forecasting/661?report_query=eJytV21v6jYU%2FiuRpUmbRq6SAIXyre3dpGqrbjdopQlVkRsb6l0nzmyHDVX89x0nATsmVLDdL4gcP%2BfF57HPOX5HmmlO0QzdFxtaaCG3wYPY0Bz%2Bh7dYURL8LCTNsNKsWAcrIYNHKUiV6eAZS4YLjQYoe8NSL7alMTN%2Feni4%2Bf0PkL5hdWcW0EzLig6QehN%2Ft4IV5spIKKeZpuQOS3IneJUXCs2W76jAuTHlOBDECDYHAcEatw41%2FcdIeMXUAy5LiBLNiorz3eBgaL%2BDYI45VcFvFRhhemsNL1ctIlUGkf7VIl66rgjNWI657w2d0EZOCAuhMQ%2BeCqZVMBecOL4rI0wVCFO25yAtOS4KsH5mBB%2FaQLuXAcopVpU0NixgZZlNlRbZ1zRvqTdeGfxRTBSg8rpNbe6VBg5Tzep9JVEyCqNJGE9hhRakI4%2BjMJ4YU3SFK65TiYu1WRzmIFwxrqkEviG4km2ETkWpG3ewWmKJ885pOJC4AA%2FB9wRv1Q82iwcKav8DOCq8AvkSDSP00n62OVSwXU67eS2q%2FBWCgc0Jqb9IYgJDcRSZRAtM6iTXh9ah9Ib8WSk4vcFCwsZtKM0h0K3wEEjsx8GZ0ieiMEvPBtpkgBE0mw7Qr%2FiVcoD9CIF9B6jnxjRKPkX1UTOwawd23UHFn64PqDhyYFMPNrWw2IFNPNjEwhIHduXBrixs6MDGHmxsYSMHNvJgIwsbO7ChBxta2JUDSzxYYmGTTnq7sNjCXBa6KItxKAi7piKHgsShIEw8mKUgcSgIhx7MUpA4FIQjD2YpSBwKwrEHsxQkDgXhlQezFCQOBeHEg1kKEoeCcOrBLAWJQ0F47cHiuoa5l3PUczdfbEtJJS0BnWbHbWXfv%2B5zvKb22rL607nfLc4i7jXNl%2BYn%2BExVJlldrrwC3deNTPksW2OO%2FW%2FW3ua%2FPFkjraNUfa0uiqxW6OuZi6agHnVKU2i9zdv61d8e69rc58POHj29%2BZx%2BdWabPKv1OQHe0jWrW2hfXK%2F7xUvHhWPFU5PCZ2qooe60QFqR0%2BcvdP%2BBhVNx3BDSCQKb7%2F8ewSl11%2F1PBTmRd1qvXOjTuzLd9AYllQEMFO4ON1RCPUgJZnybNuPVPnHn7vIDE6hvjvhfQaXO2PENAnTNucHu%2BQi%2BFOEbdsee5U2mKzgxx3f5zHBO6rv%2B74tM5OZgHGCdStEsXnoej%2FQ6ZRoyIORxgd3s5RfU2FbHO4jBnVBOG6gfBNC4lF%2FVskoCHdm2d%2FqvFXraV6CN8lH0rfSC2GuNHvvwHNCV6mlAe%2FklPajRMY28NCezeRFA936vv2G4GiAGDVg9UvlYC8ZRMxbcbs2MfWavaEcJ08VBy7xOQbKWoiprM%2FuPdt08nuCCzoXzcs3hOcMcyW5g903XxktqZhoILsM8qzg2VyqnWrJMNSbhxMEbhylRwP3TsJP33e5fTcYtcQ%3D%3D',
            },
          ],
        },
        {
          title: 'Inventory replenishment',
          icon: 'mdi-clock-outline',
          type: 'group',
          items: [
            {
              title: 'Replenishment metrics',
              link: '/board/1394',
            },
            {
              title: 'Reorder suggestion',
              link: '/reports/36/inventory-replenishment/672?report_query=eJztWW1v2zYQ%2FiuCgAEbZhW2EtuJv2XJBhRr2ixJAwxBIDAS7XClRJWkvBhB%2FvuOlG2eaNmzHaDoBn9JoONzL7wj74V%2BCTXTnIaj8H0xpYUWchZc05LTgqmnHAhhJ0yfiNS3s9Kg4POJqHNDCUdaVrQTqifx95wwJlwZCuU01TQ7JzI7F7zKCxWO7l%2FCguRGxpUUWZVaySKzqjXN782f4IKqVLJSM1E8wHpGNJkr1vTZcPCKqUtSlqyYAPFxlpRzYa%2Bdpfw7IhkpkPzpkvBvAhdIJO3m989O0lxbor5UO5lnGZDQaypkRmXwRwXamJ45DfdsEYdE4jh47shoynLCV1Su4W7TfUE0RXplTU5ACfWV1cimJozH4j8XTKvgRvAMCVfwmXydbzYpiST5lhtq4VzVZkBBCXvKCHYlmVJJJhRMZHyWVAaaWHm7GLBZCLblLPurUnDsg2ovoxThVCVa0iJ7q2lIFDbwAyVZcMtyGvwINqmfkFVwajIhEw6IRANiSwt8tsbFIWOqZ8GNFukXfBQsOVGGDIxTyrc9CSuMbaf6SjB89ZfHujT0LTU1eLASlyNbLu5ZqivCg1XMllrX8jctSEUO%2BPbMUa8lLgl83c2EDRKwERdweAIxDnDJyAkrjBAUaBsoc9CQuJKTwuC2jfkmGdikS9CeV3mb95xFsLX9fdPO3LCBPG9hA3l%2Bgw2tzG1%2BsLcuOBdTm%2BhnyvNC7dfULFvv7uADn7XNA5u0wxb21d7C2rb3T%2BtKqzG%2Fvtl7xL7J2Lbr9XrB8P30rjBivb%2BxZyg2a7WOzfJ%2BettY25Lt%2BSzlbT1Eaug7JlvL45d2OEMKZ%2FNFxTO1Dk6B8jN6WkkoeulsbalcMoavD50wp0RVkm7om0A6lLVCQUNaN3Sul1Qaet666o3CuBsfR91h1DuBFSiKDXqvG%2FWGRhQdk4rrRJJiYhaPciCOGddUQn8M9pRsKnQibP9bN9u2yWh0z8su49aW96VvcM3vQCPLK6Deh73wYf41dxFnyuuEiyp%2FBAs6dunOQGuFLAtHJ53wA3mEUjsKf%2B51uz8A6q4WHcbvujZcBnaKYKcNVO%2Fd6RLV6yLYiQc7cbAegg092NDBYgQbeLCBgx0hWN%2BD9R3sGMGOPdixg%2FUR7MiDHTnYAMFiDxY72LDh3ias52A4Ck2Uw6AQRE1RXRSCGIUgij2YC0GMQhAdeTAXghiFIDr2YC4EMQpB1PdgLgQxCkE08GAuBDEKQTT0YC4EMQpBdOLBXAhiFILo1IP1bJbggmQ2i9jxFmWoX59TXpmlQFQ6EuPIVqcga1Q8WErEOEGdDF2w4XtaCP%2BiKkDY7NoyZq5e1AGK2EeBdgGCF3sdoHD9SRUCzeBr41ZvYMgPbkXp9qVFWeANnHH%2Bth30UcD6yDZ3QPooVr0uvgYuE%2FXRXYkxJkYYdFf6GNN3mAG6KGZrDmS%2BWnz14N49TA0R0tSZdW8fwfscqpFzJrOfyN%2BHN5LvYNhaTjWr8%2FI3HW4Or0WH16LDa9F%2F8LXoO3irOTyMHB5GDg8j%2F6uHkTubRp30%2Bjv4aFa3arjqPPwt31qcpk94UvKuwMqotKWnVvhaOukA%2Fo9hk5dETliBlC66z9KuJ7ld9xRDXU7r16Cm4lbe5nlAbRXKf56rG90XSmS7eH2TjPUmXUNlLCq6hS2SamgcEjvfvdUmLGu9bXXEtjBtIoVS8yC81TQsy455pTnK9ZMcTHIv9jscwbTNYBhTV1ReWUIf5kUFQ98vMzMMr%2B%2FLH2qYGeIAaH5BBwoorUrLufiYr5s3SugSbwT6dT2vuGaI8tpxIxed1NuBARbsSQlPK07MRJpTLVmqapHQOEA7ypQo6n589PL6%2Bg9aZvwc',
            },
            {
              title: 'Replenish from warehouse',
              link: '/reports/measures/inventory_transfer_suggestion?report_query=eJztWMlu2zAQ%2FRVBpwbwoT304lvjokDQBW6W9hAEwoQay0QoUeDi1jD87x1SlE3Hm6wcetHFEGf43jxRM9KDV6nhRmA6Tn%2BDwrm0GpNbrAVWXM9LrAytmCzpKgfDZaXTUcrmoMz9snYoWs5BT1wkHRtlcZTqufwTAjMQ2kVQIDOYT0DlEylsSTTjx1VaQek4pkrmlhnHLHMXuDFYPrqf5DNqpnjtKj9RnjRAKGzwr0MIy%2FV3qGteFRR8XmZ1IFuPNvy%2FQHGoIv7FJnCOsN0Zsd19fdgyhWqZfrEd2OLdEeM1KE%2B3x%2Fq8SXRlbhERezjd5M6AsfqA9Dbe%2FXBbzIEqnmCvhmmiF1TwiPgZUgNKtWVu1skPl%2B1EvGgIIsqHiptkIvV%2BY2SWUhlrUhE3s0phxZbH2iTCxQ2DQtC2ZKo4i87G761DrEuRCBCx38vkm2R%2BNtvTCAUejcxESGVud5cJeo2JS31aABfwLDD5aeluuVkm76LyV0dKNzdkMl7RMzBSLV%2FpyJHxEsRJKXscsa6bit5Q7oQvksUD6k269kliYV%2BkQgaaZg8E6k6qZgGSaQfpoWiXYLffc1TaSPaCeeKav5si62C%2Bs%2FvIidCxllssgVfumfVUpVqC3speMew8NyXLo1M1o%2BTlc7WPOjdZOyKujgroO11nWM7MV0dxvWfsHM2pKeuordeknaLYeSsrqPQMlfIPNbR1R2EmYB30ou4%2BR3N4AN8itd8UnuQ4dIqNqvhNEBKXDf8OKF0%2FjdISQVvlQJvO2pxbpm1RoHYaHT8nC6zddeMmtg4SZ2CFyQhVBEM848KgIodLFWq%2BkCaT3sH6bzjt5xXmtK0GBaVutrUOmU6jlsp5iMElDy55cMmDSx5c8uCSB5c8uOTBJQ8u%2BT%2B55BoKDBaWHOnKr9Pxh1HKyXzqKaqpD3x8Tz6WzOv1MnhaunbOlFb%2Bf2AKFUraus37RdjgvLjV5k5G%2FxqXZKt5FFmPtm4Mi9IPYp6OqSoDwawA559LNPTtD66a5oFMNtd0fnTnJHG1Xv8DZjwqYA%3D%3D',
            },
            {
              title: 'Replenishment params',
              link: '/settings/inventory-replenishment-parameters',
            },
            {
              title: 'Incoming inventory',
              link: '/settings/incoming-inventory',
            },

          ],
        },
        {
          title: 'Replenishment by model',
          icon: 'mdi-details',
          type: 'group',
          items: [
            {
              title: 'Just-in-Time model',
              link: '/reports/36/inventory-replenishment/622',
            },
            {
              title: 'Fixed time period',
              link: '/reports/36/inventory-replenishment/627',
            },
            {
              title: 'Fixed order quantity',
              link: '/reports/36/inventory-replenishment/632',
            },
            {
              title: 'Min/max inventory quantity',
              link: '/reports/36/inventory-replenishment/602',
            },
            {
              title: 'Min/max stock cover days',
              link: '/reports/36/inventory-replenishment/601',
            },
            {
              title: 'Replenishment for bundle',
              link: '/reports/36/inventory-replenishment/672?report_query=eJztWF9P4zgQ%2FypRpJPuRLNqAm2hbyzopNUtOo4C0glVkZu44FsnztpOjwrx3W%2FslHripr1SXk66fanq8W%2F%2B2zMTv4SaaU7DcfilXNBSC7kMbmjFacnUUwGEYC5k8Lkuc06DaynyOtMq7IXZE5H6dlkZzsnd1dX5zZ9AfSLqwmyEYy1r2gvVk%2Fh7RZgTrgyFcpppml8QmV8IXhelCscPL2FJCiNqpcEoELm1StPiwfwEl1RlklWaiXIK%2BznRZKVf02fDwWumrkhVsfIRiLNlWq2EvfbW8u%2BJZKRE8hdrwr8JfEMiaZPf7pyklbZUfav3kIbRSOINFTKnMvijBlVML534B%2FaWn1Ti%2FHixyGnGCsI39G3h7tJ9STRFemVDTkEJ9ZU1yLYmjMfi70qmVTARPEfCFSzT7ytn04pIUuzpUAfnpjYDCirwKSc4lGRBJXmkYCLjy7Q20NTKe48Bu4VgW87zv2oFZz6oDzJKEU5VqiUt84%2BahkRhA79Skge3rKDBz2CT%2BgVZBacmFzLlgEg1IPa0wGdr3Royp3oZTLTIvuGjYMmpMmRgXFC%2B70nYYOw61deC4Xu%2FPtaVoe%2BpqcWDlbja2XFxzzNdEx5sYvbUupW%2FbUEmCsB3V45mL3VF4Pv7TNghARtxCYcnEPMAt5KCsNIIQYm2iTIHDYmrOCkNbt%2Bc75KBTboC7UVddEXPWQSuHR6bbuaWDeR5DxvI8wds6GTuioO9dcGFWNhCv1ReFJq4ZmbbRvcdMfBZuyKwSzu4cKj2DtYu33%2Ff1lqN%2Bc3NPiD3bcYur7frBcMP07vBiPX%2Byp6h2WzVOjfbh%2BntYu0qthfLjHfNEJmhv7PYWh6%2FtcMZUriav3U80%2BvgFCi%2Fome1hKaXLbe2yjVj%2BDrthQUlqpZ0x9wE0qGtlQqm0WbYdIOk0jDwNl1vHCb95CTqj6L4FHagKbbocT%2BKR0YUnZOa61SS8tFsHhdAnDOuqYThGOyp2ELoVNjhF%2FZh1w4ZrdF5ArN2cCsqFxUtqhJWC8JrWD6E55yH09V6FRcFUbCZ6phXmdL3BtpoYXk4Hgx74VcygwY7DgcAuW8kw3%2BTHosYOUTcRxBYrDGnDpNgTIIwZ0gTxgwcZth3GOOaA5mVSSMXJLdpth8fXRPZrR2F1hHD8xEKXOyHzcSmHbSyLmaQrc6wIX%2BP4n7%2FJ%2BzyJ%2BcPcvnorIWKP52tUTHy%2BujUg506WIxgIw82crAEwYYebOhgxwg28GAu%2B%2FEJgp14sBMHGyDYsQc7djB02o4SD5Y42KgV3jYsdjCchTbKYVAKoraoPkpBglIQJR7MpSBBKYiOPZhLQYJSEJ14MJeCBKUgGngwl4IEpSAaejCXggSlIBp5MJeCBKUgOvVgLgUJSkF05sHirqs4dS8BprAKaYrvtteA4EsBJdrdUrZaouv3RvLGVktF9%2F7H88L%2F4HkhmMHHpe1reL7EX8F2c0%2FPNvi2K21eybDS9iPFzO4f9L7RsGLVt0LDR%2BGPR5X%2F7KNK%2BxXVfft5k2vrvqCPuPcMsbtkbDcJiuGc7WPKoxRKmXIH8I%2BahGXZxlCZmDaTLdT%2BF7uGTtwLGVRldU3ltSUMoOcqaBOfl2Yg6z7i0wZiKjmAzAs0UEBhXVmut8Vq34z5cIImAr1OFzCFM0R57blKSh8bV6DfgS0Z4VnNielfBdWSZaoRmYkCrGFKlE2FGr%2B8vv4DhbHpzQ%3D%3D',
            },
          ],
        },
      ],
    },
    {
      section: 'Analytics',
      title: 'Analytics',
      icon: 'mdi-chart-bar',
      items: [
        {
          title: 'Reports library',
          icon: 'mdi-library',
          type: 'single',
          link: '/reports/0/all-categories',
        },
        {
          title: 'Inventory tracking',
          icon: 'mdi-store',
          type: 'group',
          items: [
            {
              title: 'Inventory tracking overview',
              link: '/board/1460/public',
            },
            {
              title: 'Inventory on-hand',
              link: '/reports/31?report_query=eJztWEtPGzEQ%2FivWnoqUA0WCtrlBeigqVJRXVUXRavCaxMJrL34kjaL89473kXWym7C0KhzKBeHxN983Hns94ywiy61gUT%2B6soo%2BECXJBGRC7ubkQqvEUUtuQXOQNupFdALaXs%2BzHH5zfn58%2BROtEzADPxH1rXasF5mJmpWGexDGW5hg1LJkADoZKOFSaaL%2BcBFJSD1VKeQFVOINp5alQ%2F%2BHfGaGap5ZruQI5xOwUOpb9st7CMfNOWQZl2M03s3jrCRb9lb8wQIK%2FunK8BRhhQzYrr7e1EylWmweXAe2EB0wnoDO6Rqsd6uJrsyVR8BebeOVBetMS%2BiVvXtyK58WlZygoWEL6zMUco9wD5lMlK6ZizH55mc7EU8LgoDyRnJLBso0D0bscCqmxVTATZ3WTNL5tmMS%2BIUHhgmBMPyeOA1yk2Oz0tZFJHAI2E8lrswqPSffHYbA7byWGB5T60CQJmbjY0oY5SmIhuRW%2F%2FUIqEr9AlsC4OVc%2FPg84YZfKDhQacot3idtirSafK5k07E9zbcgHNuVY3%2BkRh33tNU51L1kFrhoiIbmrlprVDtPELlgmrLwxsSNLEGr7MRZAdqQz1aumzu6jWBHmncGMvWIP45izTsM4Rw3wRmrUnKmKPjKQ941g9%2BrQ6pgw%2BqfUZzxqbLxjs%2BvRKB83KaHtViz1Xiv2wF%2BgTjCW22iMiJeJEMbUq%2BRnCdCCPMi1YwM%2FEf0AzSbKGfYP85Om%2BCr5KhLIMtRL0oZGKfZzvqCAfOUSYNOZf1e9WwgQcwtp6ZczjVuzRc%2Bnngfdg9O2FiDHPspNN1zYZluaTefbojyKwI9I6CWT1mEoStcKGCkCGePLY2HX16REZU3rWiPtZqZuCW3VAmzK7VIn4GGdK1XxoM4I7jiOmyrMhkGeyyEjzQfl6EZ3F%2BxpU%2FixuZXbaHCk6h%2FeNSLzuCOCUQdIqQoGP5%2Ff8xzxIca8X4%2FgOBghflYYw5CzEGA%2BRQohZjDGnO0X2P80mqQH%2Fl8CwVJfoDz14a3VO%2BNWLNMad%2BRbXtzkNMUxkFh5eUwSFRl2igkubXZAP%2B3j5iXeWa8dbtv3e5bt%2FvX3a6vUnh%2FlUUKL8ZFPo7673sRxyvLYCQXueEQr1%2BDd%2BjJ3NeWXZ%2FYqAD6yw6h%2FqcgtIy1clnuWw3Ked8GYLd5pYKfiVIs3TywLHv17cHG2A3Y2FcEjIiCoE6AP74ps%2FgkNgUlnmosmdwoGWN6MPzFcvkbpaGimg%3D%3D',
            },
            {
              title: 'Low stock',
              link: '/card/view/1276?report_query=eJztWW1P4zgQ%2FitRpJPudM2qDbSFfuPgTkK37LIUkFYIRSZxwbdOnLWdQoX47zd22nripr0CJ7Ra8QUU%2B5kXz9jz1sdQM81pOAo%2FivtAaZF%2BC0opsirVKuyE6R2R%2BnxWGsD44uTk4OwrrN4RdWg2wpGWFe2E6k7czxcmhCuzQjlNNc0OicwOBa%2FyQoWjq8ewILlhdVpLMAJEZhaONc2vzJ%2FgiKpUslIzUVzDfkY0mcvX9MFQ8IqpE1KWrLiFxZtZMlc3fOos%2BV8SyUiB%2BE%2BXC%2F%2FFcIFE3MZ%2FXzhOc2mJ%2BlY9Sz1LgJieUSEzKoMvFUhjeuYkXLFiSgst5CyRtOS0YOouhwXPHBlNWU74isg11G2yj4imSK6slxMQQn1hNbIpCeMx%2B4uCaRWMBc8QcwWfyff5YZOSSJJveaAWylVpBhSUcKaMYFOSKZXkloKKjM%2BSykATy%2B85CmxmgnU5yP6pFFz7oHqRUopwqhItaZG9VjXECiv4kZIsOGc5DX4FndRvSCu4NZmQCQdEogGxpQY%2BWePhkAnVs2Bsogq%2BCnY5scEGCKeUb3sTVgjbbvWpYPjpL691ada3lNSgwUKOF6%2Br7eEepLoiPFjFbCl1LX1Tg1TkgG%2BPHPVe4oLA9%2BepsIEDVuIILk8gJkjVM5oTVhgmyNHWUeaiIXYlJ4XBbevzTTywSicgPa%2FyNus5jeBoL7dNO3FDB%2FKwhQ7k4RU6tBK32cG%2BuuBQTG2gnynPCrVdU7NtrfsMG%2FikbRbYJB2O8FLpLaRtZ%2F%2B8LrUa9euX%2FQLfNwnbTr1eLij%2BMrkrhFjuX%2BwBks1aqROz%2FTK5baRtwfZwlvK2GiI1688MtpbGT%2B1whxSO5ouMZ3Id3ALlR%2FS0kpD00tnaVLkkDJ%2BuO2FOiaok3VA3AXdIa4WCgrQu6FwtqTTUvHXWG4VxN96NusOotwc7kBQb671u1BsaVnRCKq4TSYpbs7mTw%2BKEcU0lro%2F%2Fp%2FA6JbwC5FU4DOGoAioRAhgg5baaa3GNMUnJpkInwpbgsAVAW%2Bc0CvhloXNuK4ylTrjsQPJ7Rr79msvjTHnFeFHlN2CEjt26NNBaIMvC0V4n%2FEhuINuPwt973e4vgLqsWYfxh669MQa2j2D7DVTvw%2F4S1esi2J4H23OwHoINPdjQwWIEG3iwgYPtIFjfg%2FUdbBfBdj3YroP1EWzHg%2B042ADBYg8WO9iwYd4mrOdg2AtNlMMgF0RNVl3kghi5IIo9mHNBjFwQ7Xgw54IYuSDa9WDOBTFyQdT3YM4FMXJBNPBgzgUxckE09GDOBTFyQbTnwZwLYuSCaN%2BD9eyr5IJkNpDZDhsFyT8fUl6ZrUBUOhKTqG7is0bSha1ETBIUMeiCDL%2FTQvgPVQGCe8Fi0emuPtQB8tgngU4BjBdnHSB3faUKgWbwtfGo4ztxH5yL0p1Li7LABzjg%2FHUn6COH9ZFu7oL0ka96XfwMXCTqo7cSY0yMMOit9DGm7zAD9FDM0RzIfLXY6tqNXkwaE9KkunXjl%2BA4h4TojMnsJ7L3%2B5jmB%2Bj3lpl%2FtWV%2F0%2F7qbac6P%2F147H1g9T6wepuB1Q8wLnqfzbzPZt5nMz%2FVbObShlHHvf4OPpndrQquOg6%2F5bjHSfqMOyXvCay0SltaaoWupZIO4P8EDnlC5C0rkNBF9Vna%2FSS3%2B55gyMtpPZBqCm6lbd4HVOig%2BOeZulEPoUD2HKtv4rFepTPIjEVFt9BFUg2FQ2L7u9fqhHmt16322Baq3Uqh1NwJr1UN86pncuYq1yM56OQe7Xc4gm6bQTOmTqk8tQt96BcVNH1%2FzEwz3F6dX9cQ08AByPyADysgsCot1eJjvm9GpFAhjgX6cT%2BvuGZo5anj2i16Wx8FmlfQJSU8rTgx3WhOtWSpqllC0QDaMCWKujoePT49%2FQsJUCff',
            },
            {
              title: 'Out-of-stock',
              link: '/reports/288?report_query=eJztWW1v2zYQ%2FiuCgAEbZhW2EjuJv2XJBhRr2jRvQBEEAiPRDldKVEnKjRHkv%2B9I2eaJlj3bAYZu8BcDIp%2B7545H8o7nl1AzzWk4DD9VOhKjSGmRfg0upciqVKuwE6ZPROqbaWkw17cXF6dXX2D0iagzMxEOtaxoJ1RP4vtsYES4MiOU01TT7IzI7EzwKi9UOLx%2FCQuSG1UzBkMgMjPwXtP83vwE51SlkpWaieIB5jOiyYxf02cjwSumLkhZsmIMg4%2FTpJwpe%2B0s9N8RyUiB9E8WA%2F%2BkcI5E2q7%2FvHWaZmyJ%2BlptZZ4VQEqvqJAZlcHnCtiYnjqGe1ZMaKGFnCaSlpwWTD3lMOAtR0ZTlhO%2BRLlCuo37nGiKeGU9nAAJ9clqZJMJ47H624JpFVwLniHlCj6TbzNnk5JIkm%2FoUIvkMpsBBSX4lBG8lGRCJRlTMJHxaVIZaGL1bWPAeiXYltPsr0rBtg%2BqnYxShFOVaEmL7K2mIVXYwA%2BUZMENy2nwM9ikfkFWwa7JhEw4IBINiA0t8MUaB4eMqJ4G1%2BZWwVvBDif2sgHBCeWb7oQlwbZdfSkYPvqLbV2a8Q2ZGjKY5P38dLUd3NNUV4QHy5gNWVfKNy1IRQ749pujnkvcJfBtOxPWaMBGnMPmCcQImXpFc8IKowQF2gbKbDSkruSkMLhNY75OBzbpAtjzKm9bPWcRuLb72rQLN2wgzxvYQJ7fYEOrcNs62FMXnImJveinyluFel1TM21Xd4s18EXbVmAdO7iwK3uLaJvvn1alVmN%2BfbJ3iH1TsM3r1bxg%2BG68S4KY9w%2F2DMlmJevITO%2FG2ybadtmeTVPeVkOkZnzLy9bK%2BKkd9pDCt%2Fk845lcB7tA%2BTd6WklIeul0ZapcCIavD50wp0RVkq6pm0A7pLVCQUFaF3SullQaat466w3DuBsfRt2jqHcMM5AUG%2BO9btQ7MqroiFRcJ5IUYzN5kMPgiHFNJa6Pd88yE8IrQN2H3RC8E1B8EMCAGLcFXEs0zCqUbCJ0ImzVDVMAtKVNo2Zf1DY3tqhY2IMrDcTfM%2Fz2a8bHmfLq76LKH8Hvjp26M9CakGXh8LgTfiCPkOCH4a%2B9bvcnQN3VqsP4XdduEgM7QbCTBqr37mSB6nUR7NiDHTtYD8GOPNiRg8UINvBgAwc7QLC%2BB%2Bs72CGCHXqwQwfrI9iBBztwsAGCxR4sdrCjxvI2YT0Hw1FoohwGhSBqquqiEMQoBFHswVwIYhSC6MCDuRDEKATRoQdzIYhRCKK%2BB3MhiFEIooEHcyGIUQiiIw%2FmQhCjEETHHsyFIEYhiE48WM%2BeSi5IZu8u%2B6hG9%2BLvzymvzFQg8Ls9a%2BRZmErEKEH1E52L4XNaCP%2BgKkBw77KYP26XD%2BoAReyjQF6A4rmvAxSuL1Qh0BS%2B1rp6%2FSS%2BBzeidH5pURbYgVPO3%2BZBHwWsj2xzG6SPYtXr4mPgbqI%2BOisxxsQIg85KH2P6DjNAB8W45kDmq2WtHly3xWQuIU12W9VxCd7nkAPdYjL7idZ735n5AZ54jW6cVz0vHesNiZfk9s2ofTNq34z6jzejfoBW0L7vsu%2B77Psu%2F6u%2By529Rp32%2Bjv4aGY3qqzqe%2FjfbOUsVbDmX8wRcF4QOWYFYp1XfaWdT3I77zFDmkzr3k%2BTuFW2GR5U5aDryPO8UQyhe2WbRVinY7VJV5CoiopuYIukGvJ4Yt9Vb7UJ61ptWx2xDUwbS6HULAhvNQ3rqnthZmfVrTB4Qb3Y73AIr1wGjyB1SeWlHejDO03BY%2Bu3qXmEtleUDzXEPJwAZP4rhxEgrEorNf%2BYzZtuJBRs1wL9j55XXDM08tpxzxw6rl2BRyPYkhKeVpyYV2BOtWSpqlVCDgdrmBJFXRoPX15f%2FwZ%2FFPIL',
            },
            {
              title: 'Inventory remaining days',
              link: '/reports/212?report_query=eJztWW1P4zgQ%2FitRpJPudM2qDbRAv3FwJ6FbdjkKSCuEIpO4xbdOnLUdlgrx32%2FstPXETXttkdBqxRdQxs%2B8eMaeF%2Fc51ExzGg7Dj%2BJ7oLRIvwalFFmVahV2wvSBSH01LQ1gdH1%2Bfnz5BagPRJ2YhXCoZUU7oXoQ32eEMeHKUCinqabZCZHZieBVXqhwePscFiQ3oi5qDUaByAzhTNP81vwJTqlKJSs1E8UdrGdEk5l%2BTZ8MB6%2BYOidlyYoJEO%2Bnyczc8KWzkH9DJCMFkv%2B4IPyfwDkSSRv9fe0kzbQl6mu1lXmWAQm9pEJmVAb%2FVKCN6anTcMuKR1poIaeJpCWnBVMPORA8d2Q0ZTnhSypXcLfpPiWaIr2yJieghPrKamRTE8Zj8dcF0yoYCZ4h4Qo%2Bk2%2BzzSYlkSTfcEMtnMvaDCgoYU8Zwa4kj1SSCQUTGZ8mlYEmVt42BqwXgm05zv6tFBz7oNrJKEU4VYmWtMheaxoShQ38SEkWXLGcBr%2BCTeo3ZBWcmkzIhAMi0YDY0AKfrXFxyJjqaTAyWQUfBUtObLIBxkfKNz0JS4xtp%2FpCMHz1F8e6NPQNNTV4sJKz%2Be1qu7jHqa4ID5YxG2pdyd%2B0IBU54NszR72WuCTwbTsT1kjARpzC4QnEGJl6SXPCCiMEBdoGyhw0JK7kpDC4TWO%2BTgY26Ry051Xe5j1nEWxtd9%2B0MzdsIE8b2ECeXmFDK3ObH%2BytC07Eo030U%2BV5ofZrapatd7fwgc%2Fa5oF12mELu2pvYW3b%2B%2BdVpdWYX9%2FsHWLfZGzb9Wq9YPhuepcYsd6%2F2BMUm5Vax2Z5N71trG3J9mSa8rYeIjX0LZOt5fFLO5whhbP5vOKZWgenQPkZPa0kFL10urJULhjDl7tOmFOiKknX9E0gHcpaoaAhrRs610sqDT1vXfWGYdyN96PuQdQ7hBUoig16rxv1DowoOiYV14kkxcQs7uVAHDOuqYT%2BGOwp2aPQibD9L6zDqm0yGt3zosu4suV94Rtc8zvQyPIKqLdhL7ybfc1cxJnyOuGiyu%2FBgo5dujHQWiHLwuFhJ%2FxI7qHUDsPfe93uL4C6qUWH8YeuDZeBHSHYUQPV%2B3C0QPW6CHbowQ4drIdgBx7swMFiBBt4sIGD7SFY34P1HWwfwfY92L6D9RFsz4PtOdgAwWIPFjvYQcO9TVjPwXAUmiiHQSGImqK6KAQxCkEUezAXghiFINrzYC4EMQpBtO%2FBXAhiFIKo78FcCGIUgmjgwVwIYhSC6MCDuRDEKATRoQdzIYhRCKIjD9azWYILktksYsdblKH%2BfEp5ZZYCUelIjKN6gs4aFQ%2BWEjFOUCdD52z4nhbCv6gKEDa7toyZyxd1gCL2SaBdgOD5XgcoXF%2BoQqApfK3d6giG%2FOBKlG5fWpQF3sAx56%2FbQR8FrI9scwekj2LV6%2BJr4DJRH92VGGNihEF3pY8xfYcZoItituZA5qvFV3fu3cPUECFNnVn19hGc5VCNnDOZ%2FUT%2Bfn8j%2BQGGrcVUszwvv%2Blw87ZPKj%2F929T7a9H7a9HbvBb9AG817w8j7w8j7w8jP9XDyI1No056%2FR18MqsbNVx1Hn7Ltxan6TOelLwrsDQqbeipJb6WTjqA%2F2PY5DmRE1YgpfPus7TrSW7XPcVQl9P6NaipuJW3eR5Qo4Pyn%2BfqRj%2BEEtk2Xl8nY7VJl1AZi4puYIukGhqHxM53r7UJy1ptWx2xDUybSKHULAivNQ3LsmNeaY5y%2FSQHk9yz%2FQ6HMG0zGMbUBZUXltCHeVHB0PfH1AzD7d35XQ0xAxyAzK%2FnQAGFVWm55h%2BzdfM%2BCR3iSKBf1vOKa4YoLx03btFJvRUYXsGWlPC04sRMoznVkqWqFglNA1jDlCjq7nj4%2FPLyH9ne%2Bj0%3D',
            },
            {
              title: 'Inventory movement',
              link: '/reports/291?report_query=eJzNWG1v2zYQ%2FisCPwwr4ABOtmSJv6XugA1rt2xuuw%2BGIdAUY3OjSI0vTo3A%2F31HipKoF7vysKXLh0A8PnfP8UjeHf2MDDOcohn6UeyoMFLtk1zuaA7fyXqf7LBiWBg0QWSLlXm%2FLxwWhlus506CZkZZOkF6K5%2BC4BFz7SSUU2JoNscqm0tuc6HRbPmMBM6djQclM0u8ZZl5BwzNl%2B5f8oZqolhhmBQrmM%2BwwYHY0E9Og1um3%2BGiYGIDwvU%2BLYKxw6S2%2F7HxvLTfLOVzBitkZG3x04fGUmBL9Z92hLUYHVl8jZU317O6rifGWq40IushusnCYGP1gOuVfHxwK50BFm%2Bgx2FK6RkMXiPeQyoyqRrL5Tj52c2OMrwrDUQmPwhmkrnU%2FYORWphKSTkV2SZWKSrI%2FtgxifTiA0M5B1jyoBiJYuOxRZCNIYkUIuvNZf3VggvM7BuK5T0xFvOkj%2BlcpowSlmPeozyq3%2FaAyNwtcMABFubSv84j7unFhHOZ58xAPhliJNXkuZR9xeEwf8Tc0lMxdkdqNXJPB5Vj3t%2BowYz3SGPxWK6WqZMnKHmgitA4Y8JGBlAdnbQoQR36olbt7ugxAyfCfNKRnUP8Yy9a2rEL72ATrDYyT95Kgl3lSb7uO%2F%2BqcamCLauPVVqwnTTpiesXEECfDvEtAE3r8atxB%2FgF%2FIiz2lYWCX%2BRCHWovkRwPuNCHBchn5K5u0S%2FY0W30mr6H0dniPCLxGiMI4fVBOUUa6to6zpWnabzlMGHBnQo3HWzhgXme8OIDut4D3vyA9tsYQoaEgVNA%2FNbcDW9%2BvZientxeQszUPbb8ruLyxvHQh%2Bx5SZVWGzc5DfTDKSPjBuqoDkFN8uVSd98lp1ugRXOW60rnIunBPxodtPIQsDIpxdAonvO0SqMg98aws2PtC1MG5%2F5ShaWodn1zQS9xWvKAXUNkDJ%2Fu2936jziuwZxOY0gMKgxtw3mKsZcRZi7iCnGXDeYm2mDcUtrQG7kdldLZX5RmYsiunN%2FblkSZ%2F6M%2BQeBR4UnQapoAQrQNPWeBW9wVNcLqIuuH4CQdSIXJJ1%2BOIb329T%2F4VNDWM7%2FnVdG3Ke3Hxrty3gqA42jqRJi6zFDN0yII%2B3gupo8tznrK3Y7eZ0sJM8iLtcu61SDcCRHo9C3Db2TVYLG9lUQnbuUnt4QG6FsB%2F3tV8l99gcU5RZx3T8ZyF36kUK7N3aJQ6ox%2FfciO7Jz1M%2BcudbOmfYPLtJ6cC3rF9PYLvacJ9ayJR%2FJ0HF67mFm6A30Iu8sV4jwhoY6BAny2Y%2FR7HKCGOQtDS3ygxdcT8vk%2B3pf1i%2F37ZIajHzaBdFGSVtU834QAK4qwzlbyOhXmxzKI4skh0mTiOjGFevUVQRgJZgTy7FL5zk1EGtdmoQnFZRMpqUoE%2FHs%2BXD4GzZEbLE%3D',
            },
            {
              title: 'Month-end inventory',
              link: '/reports/350?report_query=eJztV91v2jAQ%2F1ciP%2ByJSsBGP3hruz1UK1JX2koTQpGbGPDm2Jk%2F2BDif9%2BdkxBDyAR75qWK7353v%2FPd4buuieVWMDIkIyXtImIyjbhcMmmVXpEOSRZU25dVjojx62h0%2B%2FwdpAtq7lFBhlY71iFmoX6XghkVBiVMsMSy9J7q9F4Jl0lDhpM1kTRDV09apS6xSKBSFDxYlk3wT%2FSZmUTz3HIlp6BPqaUlv2V%2F0EI4bkY0z7mcg%2FB9Feels01n6%2F%2BNak6ljV785bYsy0J8nFvz04Uux19fa0clpcecEmPDKaSZRY8qoXjf2n8lmVQfR6ZCVJ4Cjjs251ICJPrm4PLcrmqeyXuljH%2BVyj2mlCU8o6JJ1jAMOV8ltyYaK5EGXA6FsQHhkRy1QdP3M0sYX7I0%2BhDdpj%2BcgV4LqKqYYqupNDOmNTuW9JDpIXrrtNzh1KXo1Ew27EK2LzJtqRzzmhPJpBNivzXQ%2F0P1k4%2FeqHDsYINsn4U4Ucbu8SUO8iST1T%2F6ZNf%2BcLc06BEaq9mhrmmlDG3aK9dKVdTjVLLC6qg%2BbTDXmal6Ll4i5NgY2uwPNFJ7oct%2Bqn2dEsJeX5VkkGrKRRuT9trTaaYdkjFqnEbkghsIlidUxOHYSnnGpMGH0D%2BL9btvLEyp2HIfZr%2Fb%2F3TRvbnoXYMGotqR97oXvSt0xWbUCRtDZueo%2FNjFH%2F2MC8s0jDSIJudLBT3gRxYAQJtTTbOdgTeGCRm9qLxOg1U5PvhFoYYTcisEmZbnMg0GLu3H14GXH%2B7t81qw8JQMB5cd8kjfmQDUACBF2vEbK%2BMRVzWi1w0gcNhirmtMP8T0A8xNwBRiBjXmsltj8Go1CE9YRKFo6qvqVwaUVEsDtEauoExJ6%2BIQPWR0HvQU98egA88LxnnBOC8Y5wXjvGCcF4z%2FWDByGCflRIfxs%2FZnMux1CIcJYp6YfvKCAQw5A5PqblVsAviN4wVOfqiBaK6Vyyu9P5QAXGOgWmMV%2FNecwaLBA8mmUw8CNoeVxsY4W4EVFp7ECYrDMmMWFiBTuExUBssHN0rGcF0Icb3Z%2FAUjwoB%2F',
            },
            {
              title: 'Inventory value',
              link: '/reports/595?report_query=eJztV0tvGjEQ%2Fisrn%2FeQRCJtuaX0ErWRaEgiVQitHK8hVv2qPaZFiP%2Fe8T7NM7RnLgjPfJ7PMx5%2Fo10TECA5GZJ7veQajFtlL1QGTnLC3qiDp5WN3snzw8Pd4w%2B0vlE%2Fig4yBBd4Tvyb%2Bd0Y5lT6aOGSM%2BDliLpyZGRQ2pPhdE00VTHU2JkyMIgEpqyYgatp%2FMm%2BcM%2BcsCCMnqG%2FpEAbfuB%2F4g4ZhH%2Bg1gq9QOPrqrBNsE3exX%2BhTlCdxF92hvcCtsgk2uTrcx%2BpYSv8z3BGtBSdRDxQ6Dr69I5BoDLrASPjYacQLDjHNVvtsR3cnPI%2BcqBC7pGm5nO5tkIdTO17wDoKWGVj7hhPb2MqWlDxqwEVtgbt0Ntu6zb78QAnynzyIMuI%2BO9TbO1Oj%2FCsBdTXsNuLRUBXwWrXORXf35f2KJcSYdnYCZZcbYW1je0ckmTDyUs91bItZqeKJWdCUfl%2B13YcWydgRsUEDxxANL6uF84k3tuXEo6MUgJQwg4xstb5r5T7G8lmlhPFqQ%2BOH33CGFsorj2KYq15iZ7xOQ0SCkf1IgZA01xI4A71FiNbsTRQmEpPa6%2BljqotNZ6gfGdPxvYJgrEaV1VXI5LcSUlmzbrJ0GNCcqerWgkUHqoHV7OIkgwHtzn5Rl%2B5RNQAIbVsxP%2Bx5BXiQ4%2B4vkoguOgwH3vMTYq5STCfEqYUM%2Bgxt1c9JqbWg%2BIqXog0tKxurJpn0dJOtMJxa1x8gMemWnav6CJ5g6JaJq11mX6X6XeZfpfpd5l%2B9fSzqI%2FNiEI9XVdrMrzOiUBJ9Ni248owQNX2KL2fV3Ek7TzbWe2L%2Bone%2BFmCloUzwVbwdtH448gNHiYm%2BWRROEVFYtnkvX7xBU5fKOLswEMwKlmQNOahOGC3%2BDokpofDVXijCywGnni92fwFynWg7g%3D%3D',
            },
          ],
        },
        {
          title: 'Inventory optimization',
          icon: 'mdi-cellphone-cog',
          type: 'group',
          items: [
            {
              title: 'Inventory metrics',
              link: '/board/337',
            },
            {
              title: 'Slow-moving product',
              link: '/reports/56?report_query=eJzVV99v2jAQ_lciP_NAO9GtvHX0pdq6sdH2YaiKTGLAqmNn9pkOIf73nZ2EGAgFtNJqfajq89333V3uh7sgwEEw0iUDoZ6jWzXjchINQCVP0Wge9bVKbQLRA9WcSiAtkkyphrt57kzwOKWm5ySkC9qyFjFT9VwKxlQYJ2GCJcDSHtVpTwmbSUO6wwWRNHMYJYNDVqkT3ADLhu5XdM1MonkOXMlHvE8p0JIY2B9nISw3tzTP0WUUjuZxXoItWyv8wPMCf7YS7AGUVogAqErFAChYU-OVnLGp5If7WdkELIMv9w3QT_ZIXDQIQD9T7RG3gEeriyPAK6OG3HiELRYopEdQeIvwIzKZKl0jF-fom7s9CHhWAIQu25HgZsrS6JpCg9N5dR-nxX3AUkrWWXYYBpS_mFbRgApmkHMelNDQ956TbdS5tNmI6abCbBEqOMVOIlchxY3ESEHpefTDYpFzmAcsVwlYKqJtnQ3WlCU8o2Irwp32ZK83D1RY9pIrPWVgw43Eas1kMt_vhzPe5cNPBpSLLQdC8YG8L6T9KzUQfdcp0xvVNPQ31TeHTarGchVoEhtnslVB95JDFW3FYFEWJ0ekb2WwK2UDJoTbAn3NkzCWNfm_J-2W6gmXAf6qg7Qao4uZv9_gyZlOmNxOWqPteoCPLZIxaqx2OMZ1nPFrrpyuPGPS4KopB0a9JdiYWgGxpnJSLr0xF4BtGWyxA1t75quwOyQf2gTdURgNxQpGvQk0dv6rtPaKdR9p1fgNk93s23orEnSFz9gGE_vdUPjui-R8piBWfskXyc2pptnaE2GAb4roTuU1O6hcrnEK4Qj9uWQwWBdix3bgBnzjFyw8Jd3ORQubeMQEanVQpRgX7m-XC6_xsdY4awcqeFjpfKp1zkOd80DnMmAKdTq1zkW71nGh1Uru5NJmlAY_b1B26X5cWIqmvhn8w8trlU-vWLMcDbDp_9_n10keRm81t19z87__tn-vDX-yrX66DXvCrfq2m9TPajph5ajGGbLwZ9I9axGO48L0me57QaddzKfPczeawwovB5cbLHjlxxSKJlrZ3CtXh1LBLWxrYKCC_yYzXMU8kCwxaCoSK6ibcxkDzKIpbBOV4S7hRsmiH7uL5fIv9eEPMw',
            },
            {
              title: 'Dead stock',
              link: '/reports/207?report_query=eJztV01vGjEQ%2FSsrn4m00JIPbgk5NGqr0JLkgqKV2XXAitfe%2BIN2hfjvnfEuu2YBNVFvFRwi%2FObNPI89nglrYrkVjIzILaNZNLUqfY3mZTTRKnOpjZ6o5lRa0iPpkmr7UBbIheWSmjEiZGS1Yz1ilupXDbxQYRBhgqWWZWOqs7ESLpeGjGZrImmOMWoFjKwyBO4sy2f4J7plJtW8sFzJZ7Bn1NJa2LLf6CEcN99pUXC5AHBeJkUdbNNr4gc7r%2BKvGuAvAaUTIgg0%2FfrYBqmFEvPqPrQz7xAEvaHaR9wLPG8MHwi%2BdQoEthc4cXPBzZJl0S21B%2FSKrT3JKnsgWyO7skccA%2BlHya2JpkpkrdzMIZgYADtXmrGU51Ts6bQOYKKCU6gech3qVMV6L6MvVIZS16l1VER3csWkVbqMfji4d27Ldyof9T%2B2kW%2FU2OgnSxlf7Z3zTNe4P6buDg4ccKf6dmP7ow2CC7AmjcLbu1Pc8zuW2vXCZ1SGog3WEZMunzO9f5xBiIMamFQ0VsZ2yiVJAetopE5rJtPyYLl4h6PVwoQAKnQ2nob3s4O%2FUw3vaEfmuUdyRo3T6EUXQEoMVieG4zmTBlpZ9WTbLmQsdMvEcr%2B7QTz4fBZfnfUvwcJktoP347P%2BBYZiL9QJuDgqF2j8FGPZv3Bh4dj3W2sECtYFN9f0oi2%2BosKBYYYlD5VAIA1VME2h6oHO3g50oX99f41k3FFb2MOli2db8JWyifIToRo%2FBdU035knUxhA0YMq2o1YVcidJIVATb%2BuRQzclDjSbLmxT0itVHhGRsPzHrzHORPAGgLlqYoM3%2FFUPOOiZfTjgAKLhnPZcgYhZxBwrgKlkDNsOedxy8HUWhKu8NiM0vZeZ1gc5Ao%2FmJaima9hP6U9q57T0A8KcIBHdJrVp1l9mtWnWf3fzuqCLlg9TgBc%2BzUZ9XuEQ0szE6YnHhjGVQ%2B9KXF8hGdZN1dsfmDCX0CALLRyheduF7Ud%2Fztwxk5V8Osoh0HOA2QDWVKROkGxFefMQoqm8k1VDuOOGyWr5ztabzZ%2FACXXmCU%3D',
            },
            {
              title: 'Aging stock',
              link: '562?report_query=eJztV0tvGkEM%2FiurORMJaMmDGyGHRm0VWpJcULQyuxMYZXZmOw9ahPjvtWc37PBSybWCA2Lsz%2F5sj8cWK%2BaEk5z12WAm1CyxTmdvSWl07jOXLMAIUM6yFsvmYNzjsiQoHudghyRhfWc8bzE7179rwStISxIueeZ4PgSTD7X0hbKsP1kxBQX5GFUU5FnnJLh3vJjQV3LHbWZE6YRWL6jPwUFN7PgfspBe2O9QlhgwCqfLtI6XrVsb%2F89V6I3%2FxUbwD4fKSxk5Gn99apzURKl98x%2BKLBhETm%2FBBI97jqcbxQecvxtFBHV5k5GfSmHnPE%2FuwB3gK9%2F1aV7pI9pask17xDCiflLC2WSsZd7QTTwJU4vCnSvNeSYKkHs8jQGqQAqw1KMxzzi06oNKvoCKqQaZ8yCTe7XgymmzTH54vHfhlicyH7U%2FFsg3sC75yTMuFnt1nphaHsq0G8GBAu9037bvUNrIuURtumH4dXKKe3bHUhvMQkbLmHQj2yFTvphys1%2FOyMVBDkoqGWrrdtolzVC2w5F5Y7jKlgfbJRgc7RYuJQ24kRFZfD9b8hPZ6I62aF5arOBgvSEroEGahkFK7kTBlcVRVj3ZZgpZh9MydSJE1213P1%2B0by4616jhKt%2BSd9oXnStyxV%2FBS7w4UDNSfmpT278K6bDs0WhtOre62ZMexgKkR9SEtRlmo0tuADFoNnOHe4qSLsVCu1SHUV3thRIMFFuDfoybIXnUZROI06WKGQdSEmc41yQWSyiPTEFh3TNBKxaRs37vsoUPZcolonoIea48429qgIC4ahCddgTBwwZz3WC6MaYbYW4iphjTazCX7QZDqTUgOlHZrDbuweR0a%2ByGPpSWhjw0V1ifAVUvUHyoJRpgd5%2BX6HmJnpfoeYn%2Bt0u0hBmv1wkKV%2BHM%2Bp0WEzjS7IibURD02tUMvV3S%2BohrWQ9XGn6oor8mKJkZ7cuAfT%2FUelrb3rqxjv62FLhhRSRZY5YgMy%2BBRnHBHaZoK9tMF7juhNWqer791Xr9F5IUdk4%3D',
            },
            {
              title: 'Sell-through rate',
              link: '/reports/186',
            },
            {
              title: 'Inventory turnover rate',
              link: '/reports/345',
            },
            {
              title: 'Inventory to sales',
              link: '/reports/642',
            },
            {
              title: 'Stock availability',
              link: '/reports/668',
            },
            {
              title: 'Stockout revenue analysis',
              link: '/board/372',
            },
          ],
        },
        {
          title: 'Sales performance',
          icon: 'mdi-chart-bar',
          type: 'group',
          items: [
            {
              title: 'Business overview',
              link: '/board/117/public',
            },
            {
              title: 'Sales overview',
              link: '/board/64/public',
            },
            {
              title: 'Daily sales',
              link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2tGnethTKYP2AlL6EYlT7xhXIktBHuhDy33ev7NZKs47svXkIuUfnniNZvodsmRdeApuxCy7kJltwCY7lrHzi1t9tDK1g%2BcTdnBA28zZAztyTfu6AFZeOEJBQeqjm3FZzLUOjHJstt0zxhjRura5C6UlZVwT89NAs6Su7AFdaYbzQ6gHXK%2B55Z%2BzhN3XIINwVN0aoGsHHTWE6sV3%2BVj9beO6D6206auFe8OPlX3r%2B4hIFDjx8i%2F6HQ%2BxI9O9BVdr2ym2dXdPqUcLrVmB%2Fyyvhsytua6Gyk0urnSta8Et2Db6IN%2F6591zud3x6cycGbAnq0NzErqKJXekGomPWiZ6gY%2FuOZYNsfnO5eNf4jW0ZrAVVbg5895pS31enxOEVO1a9F0mUcd%2BpaKnro%2FWIy3YPOWuAu2CJ60i%2B0GuwawHPpCMaUA6nob3SipMMvosW3xcRNzAejr8NhtPBaIoreOP7%2BPlgdEoysOJB%2BsJyVdPi12GF6EpIDxYnE%2FdgxFr7QsfJQ0JQ2CIUEM1wy5u9AV7gxGd32vQH99oorNZcBiyX7LuU7KGru%2Bfg8NTynVdXOH9P1NZFVGw2Oc3ZL%2F4IElkTpNy3yvibHn5knPWM0TChYPHKmfacccoZJ5zzxCnlTHrO6bDn0NF6ElV0h05bf2MrepzsnD50LM2reNUxFiOrC8bCgsGGovwIx49w%2FAjHf4Wj4TV0uYRzso01m41yJnAk3C3Y2whMhu0M%2Fti0eUa%2FaV6witOHUG11MC%2FrsegIFMHB%2BYVO%2FsI0GJciQXZ5PyFQYyj7goIBXUsuyyA5TXUD3orStZKlbjA5hdMKY9vjFre73R8EUyGD',
            },
            {
              title: 'Sales by geography',
              link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2dG3etgzKYP2AlL6EYlT5xhXIktBHuhDy33ev7NROso7svXkIvkfnnnNl6V68YUEGBWzK5lyBz1jOxDN34X5tCcTwmfsZIWwaXISc%2BWfz0gJLrjwhoEAEKGfclTOjYq09my42TPOaNO6cKaMIpGxKAn4GqBf0l%2F0AL5y0QRr9iOslD7w1DvCbMlSU%2FppbK3WF4NO6sK3YNj%2FUz%2BaBh%2Bg7m5Za%2BB1%2Buvwu5y8uSeDIIzTofzikjJ7%2BA%2BjSuE65ibMbWj1JeNUI7Je8lCG75q6SOju7csb7ogE%2FZTcQinTkHzvPxX7Gh4MzseAE6GNzm7KKOmX1C0iOWSt6ho5Zc8kG2ez2av6m8YGtiM6BFusj372kvu%2BrU8%2FhFTtVvRPpKWPdfVFhqpP1iMu2jzmrgfvoiOtJvjArcCsJL6Qja9Aeu6E5UiED6eBldHhhZKpgPBx%2FGQwvBqMLXMEj38cvB6Nz0oEljyoUjuuKFj8PS0SXUgVw2JpYhJUrEwqTWg8JUWOK1EA0yx2v9zp4ji2f3Rvb7TwYqzFacRUxXLBvSrHHNm5fhMdtqzfurvThgaiNiyzZdHKes1%2F8CRSyJkh5aJTxmd5%2BYnztGKNhj4LBK%2Bei44z7nHGPc9lz6nMmHed82HFoax2JIjpEb1y4dSW9TnZJP9qW4WU66zQXE6udjIUDiwmFeJ%2BO79PxfTr%2BazpaXkE7l7BPNilm01HOJLaEvwN3l4DJsOnB7%2BtmntEz9QtGqfsQqpyJdreegpZAMzj6MDe9b5gax6XsIdu86xCocCqHggYDugquRFScurqG4KTwjaQwNU5O6Y0ucMNY4ma7%2FQPA3yAL',
            },
            {
              title: 'Product sales',
              link: '/reports/measures/total_sales?report_query=eJzNVl1r2zAU%2FStCMOhYwpJs6Ufeuox1hbXrcNaXEIxqK45Alow%2BuoaQ%2F74r2Y7luIUUlm0vIbo695xry%2FdcbbBhhlM8wTNZoK8sW6GIcKrRnZKpTYzGPZysiDKzdeFQsFwRPXURPDHK0h7WK%2FmrCiwJ1y5COU0MTadEpVPJbS40nsw3WJDccVTUjlmmLnBtaD53P%2Bgz1YlihWFSLGA%2FJYZUwoY%2BuQxumb4hRcFEBsGHdVxUZNvePj%2BKDDFWNzIVNNZ1%2FHD6OucZFU%2FQ0TBl9BUKPiPgv6cilaphLtfo1u0eRPxYErRLXjKDbojKmEAnV0pqHZfB9%2BiWmtgf%2FdtGc97OeLN3JgVVCRVd8cJnxbnPCgvwiqgiPQHF6mPro%2Bn3q%2BhF4T3ZxCpFRbLu6LaSQt2dUqCwix3K3pAEzFB3SJrI7GA%2Bh8XbRQ%2FnlGir%2FFFKQ3isq0pTllOhoRXaXzr0l4Fuiw3zFYwGo4%2F9wUV%2FeA47cOSt%2BHDQH545KroklptYEZG5zQ%2BDFKJLxg1V0JpQRMEepYmlbz0AWAEpTFAHK4gieauDI2h5BIbRPLmRhYDVI%2BEWlnN8yTleVOvqRWh4bP7Ct8u0uXfQUoWleDI%2B7eFv5IFyQI0Bcl8yw3%2F39j3irEEMBwEEFjvMeYMZhZhRgLkIlELMuMGcDhqMe7QG5FbuELkkqT9X74EuUrtgrGgh4bySF50QXeckC0yEVcvgRdWhTqN57yh3u%2BZ0NIv9KZjRKJI8DT7%2BH5YImCZrH9%2FjTmkCRfIOvYOiOjFUmLlW6DRtaSCvatuwp%2F6KJQSVo7udQ9YaQTlx5Z8HuuozmX%2FUiRqqdzPyhC5zaVuVN8FDeQOakD1aMY9AX2jw0c934deJ7KX9D%2BPmn8%2FZ49wdjnrdOealzY03MMhquoEDb%2FwaT4Y9zMATNbTpnQ%2BMwec1mPWntRtibbtZlFvOP2HT3X0hkilpC4%2BuF9W%2Bm%2BtWm0gG9%2BIcRjALItte83g0g2EPTg7DBmpICE8sJ2565NQoluiSMpE5TGOmpYjhPUDBm%2B32N%2FGL8rM%3D',
            },
            {
              title: 'Inventory sales matching',
              link: '/reports/measures/sales_on_hand_inventory?report_query=eJztVk1PGzEQ%2FSsrn4OUpA2FvUEqVahFpQpwiaKV2R0Sq157ZY%2FTRlH%2Be2e8G9Yk0I9TL%2BSAMs9v3nzYM2QrUKEGkYuZ1OCztc%2BuzBoMWrfJriWWK2WWYiDKlXR4u2mYSeZK%2BikjIkcXYCD8yv7ogEepPSOgoUSoptJVU6tDbbzI51thZM0aN85WocTsqpZLYH1bMaw6s5Iou2h7SAflr2XTcD65aFr%2Foj3dDQ6Fe8krhHrOf7KP4EunGlTWLJ7HQPiJRyEeNkUXJdW%2Fl05Jk%2Bivn4A%2FCJqgdSI0%2B3zXi%2BzL8d%2FDP2UWHRLRr64C57OpDWmKc8twUTJ6ULkJ9QO4owiJQyp%2Fa1HqLL6URP2Ts9636IF6GZwDU26O9JGFCh%2BFEv07o5CUrK4S%2BW%2BB2qtwE%2FGDABWU9AL0kT5Ts71jGqF%2F3E%2BnfaSLEgPVd8z5y6iv%2Br%2Bcwb3UAX4Xfmr94X292tEXncVuMRA1SB8cO8d%2BF9YUK2mqQu2pHEHVYDwNRvu6%2BjftkYa6QBVTHw%2FH70%2BGZyejMzoBkniGn5%2BMTlkKHmXQWDhplnz4bsiX%2Bag00jvL55RQo9YWCxsHkQjBkIsywLRGOlk%2FWxQz2izZrW36PqFtDFnr2L18Li60FovO7rrkqScaXp4k5TE2vo2iKpFPTgfii3wATawJUdp74e98bZHxoWeMhgmFjCfOWc8Zp5xxwjlPIqWcSc85HfYcLq0nscUX6q3DOOiEnfOHy7Kyig8hrt%2FI6hZw4aAhBxrmtyX8toTflvD%2FWcINTUi38mgEt9EW%2BWggFA2FvwF3E4HJsB3vyw1vtsOud7PPI0TH%2FMuLkKWzoYn8vdGd8%2BoPHmc2%2BVVW02ZWCbKjwqUug5a8KWpAp0rf%2Bpa2pm2sPP27oNIpt%2B1u9wtQs3BL',
            },
            {
              title: 'Product profitability',
              link: '/reports/measures/profit_margin?report_query=eJztVttuGjEQ%2FZWVpUqptKhASxp4a6iUVm2aSKR5QdHK7A6LVa9t%2BZIWIf49M2bDmqCoyXt4QMz4zDnjyxyxYV54CWzCbrTJvol6lV1bvRQ%2Bu%2BS2FoqiKpTesZyVK279zdoQGsMVd1PKsIm3AXLmVvpvm1hy6SgDEkoP1ZTbaqplaJRjk%2FmGKd4QR0tNzLqixHcPzZy%2Bsq%2FgSiuMF1rd4XrFPW%2BFPfyjChmEu%2BTGCFVjcrEuTEu2zff8t9wKrhL%2B%2B33iP4QqSJkQzX787khaocL9Ca%2FqLBYkpOfcRsYj4sV%2B4RXkj0WJwOE9nlxY7VyxS37IfoEvZlyCe981MD%2BsePfk5A3YEtRxFyZWFU2sShuIio%2FP6QQVs6iY9bLp1cXsWeEnsmWwFlS5PtI9KEp190qJwj73UvaOJGHGvlPSUtcv5iMs297lrAHugoWjg0Ma0YBy%2BOQPXzTOkcepKryIPQz7w0%2B9%2FllvcIYroKrD%2FLg3OCUqWPIgfWG5qmnxY7%2FC7FJIDxZHENsw4l77QscRQ0BQWCIUEMxwy5uDSZ3haGdoEN3evTbU8j2XAcM5%2ByIlu2vj9igcblw%2B84yF87cE3amIik1Gpzn7yRcgETVCyO2OGX%2FT%2BUfE5w4x6CcQDPaYsw4zTDHDBDNOlFLMqMOc9jsMba0DUUTX6LT1V7ai42Rj%2BtC2NK%2FibUf%2Fi6jWAQsLBguK8s0F31zwzQXJY2po3QenYRNjNhnkTODDd9dgr2Ni1N9N2vmaTOb4atpBpEFBAP0PwUxtdTCx4jFo18l9g%2FMznfxHadAmRZLZ5t3bhhoN2RdkCNhHyWUZJKdpbsBbUbodZakbdEzhtCrwCLDpzXb7AKM%2BG%2BE%3D',
            },
            {
              title: 'Product returns',
              link: '/board/347',
            },
          ],
        },
      ],
    },
    {
      section: 'My account',
      title: 'My account',
      icon: 'mdi-account',
      items: [
        {
          title: 'My reports',
          icon: 'mdi-chart-timeline-variant',
          type: 'single',
          link: '/my-reports',
        },
        {
          title: 'My dashboards',
          icon: 'mdi-chart-box-outline',
          type: 'single',
          link: '/my-dashboards',
        },
        {
          title: 'Recently downloaded files',
          icon: 'mdi-download',
          type: 'single',
          link: '/download-manager',
        },
        {
          title: 'Product segmentation',
          icon: 'mdi-segment',
          type: 'group',
          items: [
            {
              title: 'Product segment listing',
              link: '/product-segment',
            },
            {
              title: 'Product segment builder',
              link: '/product/explore',
            },
          ],
        },
        {
          title: 'Report scheduling',
          icon: 'mdi-bell-ring',
          type: 'group',
          items: [
            {
              title: 'Scheduled reports',
              link: '/schedules',
            },
            {
              title: 'Schedule profiles',
              link: '/schedule/profiles',
            },
            {
              title: 'Schedule templates',
              link: '/schedule/templates',
            },
            {
              title: 'Email templates',
              link: '/email-templates',
            },
            {
              title: 'Email receivers',
              link: '/email-receivers',
            },
          ],
        },
        {
          title: 'Settings',
          icon: 'mdi-cogs',
          type: 'group',
          items: [
            {
              title: 'My subscription',
              link: '/subscription',
            },
            {
              title: 'Importing status',
              link: '/importing-status',
            },
            {
              title: 'Store setting',
              link: '/settings',
            },
            {
              title: 'Plugins',
              link: '/plugins',
            },
            {
              title: 'User management',
              link: '/users',
            },
            {
              title: 'Logout',
              link: '/logout',
            },
          ],
        }
      ],
    },
  ];

  public FullMenu: any[] = [
    {
      section: 'my-reports',
      title: 'My Reports',
      items: [
        {
          title: 'Reports library',
          icon: 'mdi-library',
          type: 'single',
          link: '/reports/0/all-categories',
        },
        {
          title: 'My reports',
          icon: 'mdi-chart-timeline-variant',
          type: 'single',
          link: '/my-reports',
        },
        {
          title: 'My dashboards',
          icon: 'mdi-chart-box-outline',
          type: 'single',
          link: '/my-dashboards',
        },
        {
          title: 'Recently downloaded files',
          icon: 'mdi-download',
          type: 'single',
          link: '/download-manager',
        },
      ],
    },
    {
      section: 'Analytics',
      title: 'Analytics',
      items: [
        {
          title: 'Key metrics',
          icon: 'mdi-numeric',
          type: 'group',
          items: [
            {
              title: 'Business overview',
              link: '/board/117/public',
            },
            {
              title: 'Sales metrics',
              link: '/board/336',
            },
            {
              title: 'Finance metrics',
              link: '/board/335',
            },
            {
              title: 'Inventory metrics',
              link: '/board/337',
            },
          ],
        },
        {
          title: 'Inventory replenishment',
          icon: 'mdi-invoice-clock',
          type: 'group',
          items: [
            {
              title: 'Replenishment metrics',
              link: '/board/1394',
            },
            {
              title: 'Reorder suggestion',
              link: '/reports/36/inventory-replenishment/672?report_query=eJztWf9r4zYU%2F1eMYbCx%2BHDcJG3yW9duMHa3dddeYZRiVFtptZMtnyTnGkr%2F9z3JSfSsOFmSwr5Afgn46fO%2BS3pPLy%2BhZprTcBL%2BXM5oqYWcBx9pxWnJ1FMBhLAXZk9E6pt5ZVDw%2BUTUhaGEEy1r2gvVk%2Fi6IEwJV4ZCOc00zS%2BIzC8Er4tShZO7l7AkhZFxJUVeZ1ayyK1qTYs78xNcUpVJVmkmyntYz4kmC8WaPhsOXjP1gVQVKx%2BB%2BDBPq4Ww195K%2Fi2RjJRI%2FmxF%2BDuBSySSdv3LJydpoS1Vn%2Bu9zLMMSOhHKmROZfB7DdqYnjsNd2yZh1TiPHjhyGnGCsLXVG7g7tJ9STRFemVDTkEJ9ZU1yLYmjMfiP5VMq%2BBa8BwJV%2FCZflk4m1ZEkmJHhzo417UZUFCBTznBoSQzKskjBRMZn6e1gaZW3j4GbBeCbTnP%2F6wVbPugPsgoRThVqZa0zN9qGhKFDXxPSR7csIIG34JN6jtkFeyaXMiUAyLVgNjRAp%2BtdXDIlOp5cK1F9hlvBUtOlSED44zyXXfCGmPXrr4SDB%2F91bauDH1HTS0erMTdkR0H9zzTNeHBOmZHrRv52xZkogB8983RrKXuEviynwlbJGAjLmHzBGIa4JJREFYaISjRNlFmoyFxFSelwe2a820ysEkfQHtRF13RcxaBa4fHppu5ZQN53sEG8vwGGzqZu%2BJgT11wIWb2op8rLwpNXDOzbKO7Rwx81q4IbNMOLhyqvYO1y%2FffNpVWY35zsg%2FIfZuxy%2BvNesHww%2FSuMWK9P7FnKDYbtU7N8mF6u1i7LtuLeca7eojM0Pe8bC2PX9phDyl8my8rnql1sAuUf6NntYSil803lsoVY%2Fh63wsLSlQt6Za%2BCaRDWSsVNKRNQ%2Bd6SaWh522q3iRM4mQQxadRPIAVKIotej%2BO4hMjik5JzXUqSfloFk8KIE4Z11RCfwz2VGwmdCps%2F9s027bJaHXPqy7jxpb3VWxwze9BI8troN6F%2FfB%2B8bUIEWfK64TLungAC3p26dZAG4UsDydnvfA9eYBSOwm%2F78fxN4C6bUSHybvYpsvAxgg2bqH678YrVD9GsDMPduZgfQQ79WCnDpYg2MiDjRzsBMGGHmzoYAMEG3iwgYMNEezEg5042AjBEg%2BWONhpK7xtWN%2FBcBbaKIdBKYjaomKUggSlIEo8mEtBglIQnXgwl4IEpSAaeDCXggSlIBp6MJeCBKUgGnkwl4IEpSA69WAuBQlKQXTmwVwKEpSCaOzB%2BvaWUEJqe8sCbRCbcyJIbq8V%2B95FV9aPzxmvzVIgah2JaWTLVZC3SiAspWKaotaGLtnwwS2Ff3IVIOx12%2FHuXD%2B5I5TCXwVyCwQvnR%2Bh%2FP1BFQLN4cv3fTze5vv1k%2Fga3IjKOapFVWKPzjl%2Fm0tDlNIhMtZtoSHKZj%2FGB8XdVUN0mhKMSRAGnaYhxgwdZoSOknHNgczXevDGXfG7d9MSU3mAAarTcWKyPjH5959eqzfO%2Buv5H33qHGdHx9nRcXb0P5wd%2FQcmN8cxyXFMchyTHMck%2B41JKkNqphLQlr7Yb3hx9kIGHai6ovLKEoZx0%2FL%2BMDfd%2FuZmZNEZm84VgOZPRKA8SlFXlnP5sVg3YxoojdcC%2FcFY1FwzRHntuT6TPhotqenQwZ6M8KzmxLTXBdWSZaoRCbcl1GCmRNk0IZOX19e%2FAMDo40Q%3D',
            },
            {
              title: 'Just-in-time model',
              link: '/reports/36/inventory-replenishment/622',
            },
            {
              title: 'Fixed time period',
              link: '/reports/36/inventory-replenishment/627',
            },
            {
              title: 'Fixed order quantity',
              link: '/reports/36/inventory-replenishment/632',
            },
            {
              title: 'Min/Max inventory quantity',
              link: '/reports/36/inventory-replenishment/602',
            },
            {
              title: 'Min/max stock cover days',
              link: '/reports/36/inventory-replenishment/601',
            },
            {
              title: 'Replenishment for bundle',
              link: '/reports/36/inventory-replenishment/608',
            },
          ],
        },
        {
          title: 'Demand forecasting',
          icon: 'mdi-chart-timeline-variant-shimmer',
          type: 'group',
          items: [
            {
              title: 'Historical sales-based',
              link: '/reports/38/demand-forecasting/609',
            },
            {
              title: 'Top overstocked products',
              link: '/reports/38/demand-forecasting/609?report_query=eJzNmPFr6zYQx%2F8VYxi8sfjNceqkzW95HYOydeuWtPAIwSi2mmpPtjxLzhZK%2FvedbMc6K06bsPfDg1Kw%2FNHd6U4nfZ1XVzHFqTt1FyJ3xJYWUon4C02cvBBJGSvpDtz4hRRqscs1Nn%2B8v5%2F9%2BRlGX4i81S%2FcqSpKOnDli%2FinGXgmXOoRymmsaHJLiuRW8DLNpDtdvroZSbWpJ1IwkintQCR6YNsOJESRxqGi%2F%2BoRXjJ5T%2FKcZRt3mpWc7wetoZ9FQWMilTMnnErnjxKMMLUzhpfPDRFJTUR%2FN8Sq6yqhMUsJt725J2a7KISFUIQ7jxlT0pkLniDfpR6MJAxGLNvSTIliF%2BWcZBlYPzOCN224%2B9XATSmRZaFtGOAQt2bADUtpJpnIgFnvIpNsqaBokWLVQgI%2FuPL8CfzBG5olnfGh7%2FljbYo%2Bk5KrqCDZRr8cpTD4zLiiBS5wW5ffzb76EZKUmF32Vq30boxKTUcVrnO1JbwEaun6Lixa5LQgsFSYtlH9mdS5ydlWgLlc1YsHMCcFSWVvrAtYr%2FMhITv5vQmqjanKBgpjVMVRPTaOJWSb024wWZmuITVQVUGSqqJVh6D9M0v%2BKiW0irMoIOnGcb3jVDPYuh3aXjmT6pRPePWk0Xq9LHGn1wP3V7KmHLAfhr7%2FHVBPtWk3%2BOhX%2B1pjNwi76VDDjzctNfQRdm1h1wYbImxiYRODBQgbW9jYYCOEhRYWGuwKYVcWdmWwEGEjCxsZbIywwMICg0066e1iQ4PhKnQpw6ASeF1TPipBgErgBRZmShCgEngjCzMlCFAJvCsLMyUIUAm80MJMCQJUAm9sYaYEASqBN7EwU4IAlcC7tjBTggCVwLuxsGF1KJxsxTncYw7chqYJlcgz3H0zzs%2Fp%2BsPNddx%2FIVpFiGIzWQvRAoY%2B3humPUO0gQLMBIhBGyjETGiYMdo9emkG0k89uVqZqz0qaC7g9oiPr%2FeHWkCYNN4pmi71P%2BcnKuOCVefxqj9nndsPbqtGjeAr96vJh%2Fkvj8ZI4yiSX8qLIqsmfFuaxAphlooSp8sOgFTvLfdxWcDdE%2B%2Fe819P7vV%2Bd9AjbRKc3yjFCqlXsZyZh3610xfH1xMhl5THnv%2FtiEYkPrYbFIUDosoB%2FYOiIdtNpK39z4DeM9OJ6SCI3gkMBOCGRglhfBehBSPddHZw75vCAbabWWTOC8GabTmLVQmFPd74Z4Zycj72f5fFIgXeYJ2Oql9eeqoczevtpEUtgo96RYtjy5FRof3tUenpt0%2BN6jKyj4zWgNlF1XV88fFlzcex6J3n3AqprL6Ey06efU62E7DlOeVcl%2B6hYDHOZGf8TA%2FWZYbaZb1z5pUskf0HS61ZLj9MGq1z0uknOO5OOl1XLy93Ws%2BrP%2Bd0m9ZfcyA4XqtnkMoDl4G2kA%2B0eKgGQpA1ErTJp53WbG%2Bd6Ksa1KoEUP1rBoxsClHm1dzDQ%2FNef2zD0TQX6JeOFL6GGRrZw9oJj0tOtEZKqYKCynouNBh8fTIpMjhqFMT5ut%2F%2FB7IlzzA%3D',
            },
            {
              title: 'Top understocked products',
              link: '/reports/38/demand-forecasting/609?report_query=eJzNmPFr6zYQx%2F8VYxi8sfjNceq0zW99HYOydeuWtPAIxai2mmpPtjxJzhZK%2F%2FedZCc6q06bsPfDg1Kw%2FNHd6U4nfZ3nUDPNaTgLF6IObquCymCuRf4luCOSkUqrcBTmT0TqxaY22Pz2%2Bvriz88w%2BkTUpXkRzrRs6ChUT%2BKfbuCRcGVGKKe5psUlkcWl4E1ZqXC2fA4rUhpTnQfjQBRmYL0bKIgmnUNN%2FzUjvGHqmtQ1q1bhrGo4fxntDP0sJM2J0sGccKqCPxowwvTGGV4%2BdkSmDJH93RH3fVcFzVlJuO8t3DM7RCEshCYc8se0CuaCF8h3YwYzBYMZq9a00kJuspqTqgLrB0bwpo3w5X4UlpSoRhobDtjGbRhww0paKSYqYB42mUu20lC0TDO7kCROTqL4FP7gDa2K3vg4juKpMUUfScN1Jkm1Mi8nJQw%2BMq6pxAXe1eX3NZXK7Cpa%2FNhusu7pzVoJmJU1hs4sbnK1JrwBahnGISxa1FQSWCpM43o4kyY3NVsLMFfrdvEA1kSSUg3GuoD1Bh8KslHfu6B2MdlsoDAmNg772DlWkG1O%2B8FUTfkAqYGqClLYitoOQfvnovirUdAqwUJC0p3jdsfpbnDndux75UzpfT7h1Z1B2%2FWyIpydjcJfyQPlgP0wjuPvgLprTYfJx9jua4OdI%2By8R40%2Fnu%2BocYywMw87c9gYYaceduqwBGFTD5s6bIKw1MNSh50g7MTDThyWImziYROHTRGWeFjisNNeevvY2GG4Cn3KMagEUd9UjEqQoBJEiYe5EiSoBNHEw1wJElSC6MTDXAkSVIIo9TBXggSVIJp6mCtBgkoQnXqYK0GCShCdeZgrQYJKEJ172NgeCntbcQ73WAC3oWtCLeoKd98F54d0%2Ffbmet1%2FKVpFimJzWUvRAsYx3huuPVO0gRLMJIhBGyjFTOqYKdo9ZmkOMk8Dubp3V3smaS3g9shfX%2B83UhRNjq73K03LpfkX%2FERVLpk9j%2B%2BHc9a7%2FeC2qjtjqE5fTT7Mf7l1RjpHmfrSHBWZnfBtaRIvhItSNDhdfgDEvvfc542EuyffvOe%2FnTzo%2FWqrR3ZJCH6jFCukQcVyYB6G1c5QHF9PhBxTHn%2F%2BtyMakfhYr1AUAYiqAPQPioasV5mx9j8Des9ML6atIHonMBCAK5oVhPFNhhaMdNPBwb1vCge428yiCp4I1mzLi1w3UNjXG%2F%2FAUPbOx%2F6vqlyUwDus11Hty2NPlVfzBjtp0YrgV71ixLHnyKnQ4fawevrtU8NeRv6RsTPgdpG9jo8%2Bvrz5OBaz84JLobTXl3DZqYPPyd0EbHlOOTelu5Esx5nsjR%2FowbvMULs8bIK5lSVq%2BGBpNcvxh0mndfY6%2FQTH3V6nD%2Fbl8U7bee3nnGnT9msOBMezfQapPAoZaAt1Q%2BWNHUhB1ijQJp82RrO9daLft6BRJYBajQNDKyma2k7ePnSA%2BdqGs2ku0E8dJXwOMzTyAosnPG84MSKppBoqqtq50GHw%2BcmUqOCs0RDo88vLf48Gzs0%3D',
            },
            {
              title: 'Inventory movement-based',
              link: '/reports/38/demand-forecasting/661',
            },
          ],
        },

        {
          title: 'Inventory tracking',
          icon: 'mdi-store',
          type: 'group',
          items: [
            {
              title: 'Inventory tracking overview',
              link: '/board/1460/public',
            },
            {
              title: 'Inventory on-hand',
              link: '/reports/31',
            },
            {
              title: 'Low stock',
              link: '/card/view/1276',
            },
            {
              title: 'Out-of-stock',
              link: '/reports/288',
            },
            {
              title: 'Inventory remaining days',
              link: '/reports/212',
            },
            {
              title: 'Inventory movement',
              link: '/reports/291',
            },
            {
              title: 'Month-end inventory',
              link: '/reports/350',
            },
            {
              title: 'Inventory value',
              link: '/reports/595',
            },
          ],
        },
        {
          title: 'Inventory optimization',
          icon: 'mdi-cellphone-cog',
          type: 'group',
          items: [
            {
              title: 'Slow-moving product',
              link: '/reports/56?report_query=eJzVV99v2jAQ_lciP_NAO9GtvHX0pdq6sdH2YaiKTGLAqmNn9pkOIf73nZ2EGAgFtNJqfajq89333V3uh7sgwEEw0iUDoZ6jWzXjchINQCVP0Wge9bVKbQLRA9WcSiAtkkyphrt57kzwOKWm5ySkC9qyFjFT9VwKxlQYJ2GCJcDSHtVpTwmbSUO6wwWRNHMYJYNDVqkT3ADLhu5XdM1MonkOXMlHvE8p0JIY2B9nISw3tzTP0WUUjuZxXoItWyv8wPMCf7YS7AGUVogAqErFAChYU-OVnLGp5If7WdkELIMv9w3QT_ZIXDQIQD9T7RG3gEeriyPAK6OG3HiELRYopEdQeIvwIzKZKl0jF-fom7s9CHhWAIQu25HgZsrS6JpCg9N5dR-nxX3AUkrWWXYYBpS_mFbRgApmkHMelNDQ956TbdS5tNmI6abCbBEqOMVOIlchxY3ESEHpefTDYpFzmAcsVwlYKqJtnQ3WlCU8o2Irwp32ZK83D1RY9pIrPWVgw43Eas1kMt_vhzPe5cNPBpSLLQdC8YG8L6T9KzUQfdcp0xvVNPQ31TeHTarGchVoEhtnslVB95JDFW3FYFEWJ0ekb2WwK2UDJoTbAn3NkzCWNfm_J-2W6gmXAf6qg7Qao4uZv9_gyZlOmNxOWqPteoCPLZIxaqx2OMZ1nPFrrpyuPGPS4KopB0a9JdiYWgGxpnJSLr0xF4BtGWyxA1t75quwOyQf2gTdURgNxQpGvQk0dv6rtPaKdR9p1fgNk93s23orEnSFz9gGE_vdUPjui-R8piBWfskXyc2pptnaE2GAb4roTuU1O6hcrnEK4Qj9uWQwWBdix3bgBnzjFyw8Jd3ORQubeMQEanVQpRgX7m-XC6_xsdY4awcqeFjpfKp1zkOd80DnMmAKdTq1zkW71nGh1Uru5NJmlAY_b1B26X5cWIqmvhn8w8trlU-vWLMcDbDp_9_n10keRm81t19z87__tn-vDX-yrX66DXvCrfq2m9TPajph5ajGGbLwZ9I9axGO48L0me57QaddzKfPczeawwovB5cbLHjlxxSKJlrZ3CtXh1LBLWxrYKCC_yYzXMU8kCwxaCoSK6ibcxkDzKIpbBOV4S7hRsmiH7uL5fIv9eEPMw',
            },
            {
              title: 'Dead stock',
              link: '/reports/207',
            },
            {
              title: 'Aging stock',
              link: '/reports/562',
            },
            {
              title: 'Sell-through rate',
              link: '/reports/186',
            },
            {
              title: 'Inventory turnover rate',
              link: '/reports/345',
            },
            {
              title: 'Inventory to sales',
              link: '/reports/642',
            },
            {
              title: 'Stock availability',
              link: '/reports/668',
            },
            {
              title: 'Stockout revenue analysis',
              link: '/board/372',
            },
          ],
        },
        {
          title: 'Sales performance',
          icon: 'mdi-chart-bar',
          type: 'group',
          items: [
            {
              title: 'Sales overview',
              link: '/board/64/public',
            },
            {
              title: 'Daily sales',
              link: '/reports/measures/sales_overview?dimension=by_day&title=Daily%20Sales',
            },
            {
              title: 'Sales by geography',
              link: '/reports/measures/sales_overview?dimension=by_city&title=Sales%20by%20City',
            },
            {
              title: 'Sales by locations',
              link: '/reports/measures/sales_overview?dimension=by_location&title=Sales%20by%20Location',
            },
            {
              title: 'POS sales',
              link: '/reports/measures/total_sales?dimension=by_product&pivot_option=_rows_Location%5BLocation%5D_cols_%5BQuantitySold%5D&params=ShowTop__topn__text__single__All',
            },
          ],
        },
        {
          title: 'Product analytics',
          icon: 'mdi-tshirt-crew',
          type: 'group',
          items: [
            {
              title: 'Product sales',
              link: '/reports/measures/total_sales?dimension=by_product&analytic=TopHigh&title=Top%20High%20Sales%20Products',
            },
            {
              title: 'Inventory sales matching',
              link: '/reports/measures/sales_on_hand_inventory?dimension=by_variant&title=Sales%20vs%20Inventory%20Matching',
            },
            {
              title: 'Product profitability',
              link: '/reports/measures/ProfitMargin?dimension=by_product&analytic=TopHigh&title=Top%20High%20Profit%20Margin%20Products',
            },
            {
              title: 'Product returns',
              link: '/board/347',
            },
          ],
        },
      ],
    },

    {
      section: 'product-features',
      title: 'Product features',
      items: [
        {
          title: 'Product segmentation',
          icon: 'mdi-segment',
          type: 'group',
          items: [
            {
              title: 'Product segment listing',
              link: '/product-segment',
            },
            {
              title: 'Product segment builder',
              link: '/product/explore',
            },
          ],
        },
        {
          title: 'Report scheduling',
          icon: 'mdi-bell-ring',
          type: 'group',
          items: [
            {
              title: 'Scheduled reports',
              link: '/schedules',
            },
            {
              title: 'Schedule profiles',
              link: '/schedule/profiles',
            },
            {
              title: 'Schedule templates',
              link: '/schedule/templates',
            },
            {
              title: 'Email templates',
              link: '/email-templates',
            },
            {
              title: 'Email receivers',
              link: '/email-receivers',
            },
          ],
        },
        {
          title: 'Plugins',
          icon: 'mdi-toy-brick-search',
          type: 'single',
          link: '/plugins',
        },
        {
          title: 'User management',
          icon: 'mdi-account-multiple-plus',
          type: 'single',
          link: '/users',
        },
        {
          title: 'Recently downloaded files',
          icon: 'mdi-download',
          type: 'single',
          link: '/download-manager',
        }
      ],
    },
    {
      section: 'store-settings',
      title: 'Store settings',
      items: [
        {
          title: 'My subscription',
          icon: 'mdi-account-credit-card',
          type: 'single',
          link: '/subscription',
        },
        {
          title: 'Importing status',
          icon: 'mdi-autorenew',
          type: 'single',
          link: '/importing-status',
        },
        {
          title: 'Store setting',
          icon: 'mdi-cogs',
          type: 'single',
          link: '/settings',
        },
        {
          title: 'Book live demo',
          icon: 'mdi-calendar-account',
          type: 'single',
          link: '/live-demo',
        },

      ],
    },
  ];

  public freeMenu: any[] = [
    {
      section: 'Analytics',
      title: 'Analytics',
      items: [
        {
          title: 'Reports library',
          icon: 'mdi-library',
          type: 'single',
          link: '/reports/0/all-categories',
        },
        {
          title: 'Inventory Tracking',
          icon: 'mdi-store',
          type: 'group',
          items: [
            {
              title: 'Inventory tracking overview',
              link: '/board/1460/public',
            },
            {
              title: 'Inventory on-hand',
              link: '/reports/31',
            },
            {
              title: 'Low stock',
              link: '/card/view/1276',
            },
            {
              title: 'Out-of-stock',
              link: '/reports/288',
            },
            {
              title: 'Inventory remaining days',
              link: '/reports/212',
            },
          ],
        },
        {
          title: 'Sales Performance',
          icon: 'mdi-chart-bar',
          type: 'group',
          items: [
            {
              title: 'Sales overview',
              link: '/board/64/public',
            },
            {
              title: 'Daily sales',
              link: '/reports/measures/sales_overview?dimension=by_day&title=Daily%20Sales',
            },
            {
              title: 'Sales by geography',
              link: '/reports/measures/sales_overview?dimension=by_city&title=Sales%20by%20City',
            },
            {
              title: 'Sales by locations',
              link: '/reports/measures/sales_overview?dimension=by_location&title=Sales%20by%20Location',
            },
            {
              title: 'POS sales',
              link: '/reports/measures/total_sales?dimension=by_product&pivot_option=_rows_Location%5BLocation%5D_cols_%5BQuantitySold%5D&params=ShowTop__topn__text__single__All',
            },
          ],
        },
      ],
    },

    {
      section: 'My account',
      title: 'My account',
      icon: 'mdi-account',
      items: [
        {
          title: 'My reports',
          icon: 'mdi-chart-timeline-variant',
          type: 'single',
          link: '/my-reports',
        },
        {
          title: 'My dashboards',
          icon: 'mdi-chart-box-outline',
          type: 'single',
          link: '/my-dashboards',
        },
        {
          title: 'Recently downloaded files',
          icon: 'mdi-download',
          type: 'single',
          link: '/download-manager',
        },
        {
          title: 'Product segmentation',
          icon: 'mdi-segment',
          type: 'group',
          items: [
            {
              title: 'Product segment listing',
              link: '/product-segment',
            },
            {
              title: 'Product segment builder',
              link: '/product/explore',
            },
          ],
        },
        {
          title: 'Report scheduling',
          icon: 'mdi-bell-ring',
          type: 'group',
          items: [
            {
              title: 'Scheduled reports',
              link: '/schedules',
            },
            {
              title: 'Schedule profiles',
              link: '/schedule/profiles',
            },
            {
              title: 'Schedule templates',
              link: '/schedule/templates',
            },
            {
              title: 'Email templates',
              link: '/email-templates',
            },
            {
              title: 'Email receivers',
              link: '/email-receivers',
            },
          ],
        },
        {
          title: 'Settings',
          icon: 'mdi-cogs',
          type: 'group',
          items: [
            {
              title: 'My subscription',
              link: '/subscription',
            },
            {
              title: 'Importing status',
              link: '/importing-status',
            },
            {
              title: 'Store setting',
              link: '/settings',
            },
            {
              title: 'Plugins',
              link: '/plugins',
            },
            {
              title: 'User management',
              link: '/users',
            },
            {
              title: 'Logout',
              link: '/logout',
            },
          ],
        }
      ],
    },
  ];

  public googleSpreadsheetIntegrationMenu: any[] = [
    {
      section: 'Google Spreadsheet Integration',
      title: 'Google Spreadsheet Integration',
      items: [
        {
          title: 'Google Spreadsheets Templates',
          icon: 'mdi-google-spreadsheet',
          type: 'single',
          link: '/spreadsheet-templates',
        },
        {
          title: 'Connected Google Spreadsheets',
          icon: 'mdi-table-sync',
          type: 'single',
          link: '/spreadsheet-connected',
        },
      ],
    },
  ];

  public demoStoreName: string = 'assisty-demo.myshopify.com';

  public get avatarColor() {
    const s = this.store.information.name[0].toUpperCase();
    const value = s.charCodeAt(0);
    return avatarColor[value % avatarColor.length];
  }

  public get isTestingStore() {
    const testingStores = [
      'dariustest2.myshopify.com',
      'the-best-mega-store.myshopify.com',
      '2dba1f-4.myshopify.com',
    ];
    return testingStores.includes(this.store.shopName);
  }

  public created() {
    //this.checkIsMenuPinned();
    if (!this.isEmbeddedMode && this.FullMenu[this.FullMenu.length - 1]) {
      this.FullMenu[this.FullMenu.length - 1].items.push({
        title: 'Logout',
        icon: 'mdi-logout',
        type: 'single',
        link: '/logout',
      },)
    }

    if (this.isAssistyAdmin) {
      let newMenu: any = [];
      for (const item of this.googleSpreadsheetIntegrationMenu) {
        newMenu.push(item);
      }
      for (const item of this.replenishmentMenu) {
        newMenu.push(item);
      }
      this.replenishmentMenu = newMenu;
    }
  }

  public checkIsMenuPinned() {
    //get isPinMenu from local storage
    let isPinMenu = localStorage.getItem("isPinMenu") || "false";
    if (isPinMenu === "true") {
      this.canExpandOnHover = false;
      this.mini = false;
    } else {
      this.canExpandOnHover = true;
      this.mini = true;
    }
  }
  public searchReport() {
    this.$router.push('/reports/0/all-categories?keyword=' + this.search);
    this.search = '';
  }

  public doLogout() {
    this.$emit('logout');
  }

  public handleMenuClick(item: any) {
    if (item === '/logout') {
      this.doLogout();
    }
  }

  public get isAssistyAdmin() {
    
    if (localStorage.getItem("isAssistyAdmin") !== "true") {
      return false;
    }
    if (localStorage.getItem("loggedInFromHades") !== "true") {
      return false;
    }
    return true;
  }
}
